export const pl = {
  translation: {
    // WebChat
    chat_with_provider: 'Czat z lekarzem',
    //Main Menu

    menu_messages: 'Wiadomości',
    menu_household: 'Gospodarstwo domowe',
    menu_my_profile: 'Profil medyczny',
    menu_settings: 'Ustawienia',
    menu_log_out: 'Wyloguj',

    // Register Section

    register_title2: 'Zacznijmy',
    register_subtitle2:
      'Zbieramy Twoje imię i nazwisko oraz datę urodzenia, aby zweryfikować Twoją tożsamość i zapewnić bezpieczeństwo Twoich danych osobowych.',
    register_agree: 'Rejestrując się, akceptuję',
    register_terms: 'Regulamin',
    register_privacy: 'Politykę Prywatności',
    register_and: 'oraz potwierdzam',
    register_newsletter: 'Chcę otrzymywać newsletter TapTelehealth.',
    register_continue_button: 'Kontynuj',
    register_have_already: 'Masz już konto?',
    continue_with_google: 'Kontynuj z Google',
    or: 'LUB',

    // Login Section
    log_in_account_question: 'Nie masz jeszcze konta?',
    log_in_sign_up: 'Zarejestruj się',

    // Home Dashboard

    welcome:
      'Witamy w Tap Telehealth! Poniżej znajdują się kolejne kroki, które pomogą nam lepiej leczyć Ciebie i Twoje gospodarstwo domowe.',
    hello: 'Cześć',
    need_med_care_title: 'Potrzebujesz opieki medycznej?',
    need_med_care_text:
      'Napisz natychmiast do jednego z naszych lekarzy w sprawie wszelkich nienaglących<br/> potrzeb medycznych.',
    text_doctor_button: 'Napisz do lekarza teraz',
    complete_profile_title: 'Uzupełnij swój profil medyczny',
    complete_profile_description:
      'Skonfiguruj swój profil medyczny, aby przyszła opieka była płynniejsza, szybsza i bardziej spersonalizowana, gdy się z nami skontaktujesz.',
    start_button: 'Start',

    //Quick Access

    quick_access_title: 'Szybki dostęp',
    quick_access_1_title: 'Zarządzaj gospodarstwem domowym',
    quick_access_1_text:
      'Łatwo dodawaj członków rodziny i uzupełniaj ich profile medyczne, aby upewnić się, że są gotowi na bezproblemową opiekę, gdy jej potrzebują.',
    quick_access_1_cta: 'Zarządzaj gospodarstwem',

    quick_access_2_title: 'Sprawdź historię',
    quick_access_2_text:
      'Łatwy dostęp do poprzednich sesji, recept, skierowań, zwolnień lekarskich i więcej w jednym wygodnym miejscu.',
    quick_access_2_cta: 'Zobacz historię',

    quick_access_3_title: 'Dowiedz się więcej',
    quick_access_3_text:
      'Dowiedz się więcej o TapTelehealth i wielu sposobach, w jakie możemy wspierać Twoją drogę do zdrowia.',
    quick_access_3_cta: 'Dowiedz się więcej o Tap Telehealth',

    // Menu additions
    menu_home: 'Strona główna',
    drawer_menu_title: 'Menu',
    menu_open: 'Otwórz menu',
    time_2_min: '2min',

    // Alts and misc
    alt_logo: 'Logo',
    alt_profile_icon: 'Ikona profilu',
    time_8_min: '8min',

    //Household

    household_title: 'Gospodarstwo domowe',
    household_add_pharmacy_banner_title: 'Dodaj preferowaną aptekę',
    household_add_pharmacy_banner_description:
      'Podziel się informacjami o preferowanej aptece, aby pomóc nam wysyłać recepty do najbardziej dogodnej dla Ciebie lokalizacji.',
    household_add_pharmacy_banner_cta: 'START',
    household_s_member: 'członek gospodarstwa',
    household_members: 'Członkowie gospodarstwa',
    household_add: 'Dodaj',
    household_member: 'Nieletni',
    household_preferred_pharmacies_title: 'Preferowana apteka',
    household_owner: 'Właściciel gospodarstwa',
    self: 'Ja',
    address_not_available: 'Adres niedostępny',
    before_change_address_title: 'Zanim zmienisz adres',
    before_change_address_body:
      'Aktualizacja adresu zostanie zastosowana do wszystkich członków Twojego gospodarstwa domowego. Jeśli chcesz zmienić adres tylko dla siebie, musisz najpierw opuścić to gospodarstwo.',
    leave_this_household: 'Opuść to gospodarstwo',
    change_address_for_everyone: 'Zmień adres dla wszystkich',
    change_your_address_title: 'Zmień swój adres',
    household_add_member_rights_notice:
      'Dodając dziecko do swojego gospodarstwa domowego, potwierdzasz, że masz prawo do zarządzania jego informacjami medycznymi i innymi danymi osobowymi. Obejmuje to działanie jako rodzic, opiekun prawny lub upoważniony przedstawiciel.',
    household_added_to_your_household: '{{name}} został dodany do Twojego gospodarstwa!',
    household_add_another_member: 'Dodaj kolejnego członka gospodarstwa',

    //Settings

    settings_title: 'Ustawienia',
    settings_smenu_login_security: 'Logowanie i bezpieczeństwo',
    settings_smenu_household: 'Zarządzanie gospodarstwem',
    settings_smenu_billing: 'Rozliczenia',
    settings_smenu_notifications_privacy: 'Powiadomienia i prywatność',
    settings_email_preferences_card_title: 'Preferencje e-mail',
    settings_email_preferences_card_subtitle: 'Aktualizacje i oferty',
    settings_email_preferences_card_description:
      'Otrzymuj aktualizacje o naszych usługach, oferty specjalne i porady zdrowotne.',
    settings_sms_preferences_card_title: 'Wiadomości SMS',
    settings_sms_preferences_card_subtitle: 'Ogólne informacje zdrowotne i aktualizacje związane z usługą',
    settings_sms_preferences_card_description:
      'Włącz to, jeśli chcesz otrzymywać wiadomości tekstowe od Tap TeleHealth dotyczące przypomnień o zdrowiu publicznym, aktualizacji usług i treści edukacyjnych. Mogą obowiązywać opłaty za wiadomości i dane. Możesz zmienić swoje preferencje w dowolnym momencie. Te wiadomości są opcjonalne i nie są wymagane do korzystania z Usług Tap Telehealth.',
    settings_privacy_card_title: 'Prywatność',
    settings_privacy_card_subtitle: 'Umowa prywatności (HIPAA)',
    settings_privacy_card_description:
      'Rozumiem, że Tap Telehealth może nie być w pełni zgodny z HIPAA. Korzystając z tej usługi, akceptuję wszelkie związane z tym ryzyko i wyrażam zgodę na wykorzystanie moich informacji zdrowotnych w zakresie niezbędnym do świadczenia usług telemedycznych.',
    settings_privacy_card_subtitle2: 'Regulamin',
    settings_privacy_card_description2:
      'Zapoznaj się z warunkami, które regulują korzystanie z naszej platformy i usług, aby zapewnić zgodność i przejrzystość.',
    settings_privacy_card_terms_link: 'Przeczytaj Regulamin',
    settings_privacy_card_subtitle3: 'Polityka prywatności',
    settings_privacy_card_description3:
      'Dowiedz się, jak zbieramy, wykorzystujemy i chronimy Twoje dane osobowe oraz poznaj swoje prawa do prywatności.',
    settings_privacy_card_policy_link: 'Przeczytaj Politykę Prywatności',

    settings_billing_card_title: 'Rozliczenia',
    settings_billing_card_subtitle:
      'Twoja usługa TapTelehealth jest wygodnie rozliczana przez dostawcę mediów, co sprawia, że pozostanie w kontakcie z wysokiej jakości opieką zdrowotną jest proste i bezproblemowe.',
    settings_billing_card_subtitle2:
      'Jeśli nie jesteś już zainteresowany korzystaniem z tej usługi, dowiedz się, jak zrezygnować, klikając poniższy link.',
    settings_billing_card_cta: 'Dowiedz się więcej',

    settings_account_deletion_card_title: 'Usunięcie konta',
    settings_account_deletion_card_description:
      'Usuwając konto, wszystkie dokumenty medyczne, informacje o poprzednich sesjach, profile nieletnich i powiązane dane zostaną trwale usunięte. Tej czynności nie można cofnąć.',
    settings_account_deletion_card_subtitle: 'Konto',
    settings_account_deletion_card_cta: 'Usuń',

    //Footer
    footer_contact: 'KONTAKT',
    footer_how_it_works: 'Jak to działa',
    footer_what_we_treat: 'Co leczymy',
    footer_about: 'O nas',
    footer_blog: 'Blog',
    footer_partner: 'Współpracuj z nami',

    // Miscellaneous
    back: 'Wstecz',
    edit: 'Edytuj',
    cancel: 'Anuluj',
    update: 'Aktualizuj',
    confirm: 'Potwierdź',
    save: 'Zapisz',
    delete: 'Usuń',
    done: 'Gotowe',
    next: 'Dalej',
    continue: 'Kontynuuj',
    skip_for_now: 'Pomiń na razie',
    search: 'Szukaj',
    add: 'Dodaj',
    added: 'Dodano',
    miles: 'mile',
    yes_remove: 'Tak, usuń',
    yes_add: 'Tak, dodaj {{item}}',
    loading: 'Ładowanie',
    yes: 'Tak',
    no: 'Nie',
    na: 'N/D',
    unknown: 'Nieznane',
    are_you_sure: 'Czy jesteś pewny?',
    remove_household_member_confirm: 'Czy chcesz usunąć tego członka gospodarstwa?',
    remove_pharmacy_confirm:
      'Czy na pewno chcesz usunąć tę aptekę z listy preferowanych aptek Twojego gospodarstwa domowego?',
    please_enter_first_name: 'Proszę podać imię',
    please_enter_middle_name: 'Proszę podać drugie imię (jeśli dotyczy)',
    please_enter_last_name: 'Proszę podać nazwisko',
    must_be_younger_18: 'Musi być młodszy niż 18 lat',
    must_be_18_or_older: 'Musisz mieć co najmniej 18 lat',

    // Demographics Module
    terms_of_use: 'Regulamin',
    privacy_policy: 'Polityka Prywatności',
    and: 'i',
    sign_up: 'Zarejestruj się',

    demographics_setup_title: 'Skonfigurujmy Cię!',
    demographics_first_name: 'Imię',
    demographics_middle_name: 'Drugie imię',
    demographics_last_name: 'Nazwisko',
    demographics_full_name: 'Pełne imię i nazwisko',
    demographics_email: 'Adres e-mail',
    demographics_dob: 'Data urodzenia',
    demographics_dob_placeholder: 'MM/DD/RRRR',
    demographics_gender: 'Płeć',
    demographics_gender_male: 'Mężczyzna',
    demographics_gender_female: 'Kobieta',
    demographics_gender_other: 'Inna',
    demographics_gender_unknown: 'Nieznana',
    demographics_street_address: 'Adres ulicy',
    demographics_address_line_2: 'Adres linia 2',
    demographics_city: 'Miasto',
    demographics_zip_code: 'Kod pocztowy',
    demographics_state: 'Stan',
    demographics_current_state: 'Stan, w którym się obecnie znajdujesz',
    demographics_address: 'Adres',
    demographics_use_current_location: 'Użyj mojej obecnej lokalizacji',
    demographics_continue: 'Kontynuj',
    demographics_error_current_location: 'Nie udało się pobrać Twojej obecnej lokalizacji',
    demographics_add_address_manually: 'Dodaj ręcznie',

    demographics_consent_title: 'Tylko szybka kontrola zgody',
    demographics_consent_body_line1:
      'Wiadomości tekstowe, podobnie jak połączenia telefoniczne i poczta głosowa, mogą nie być w 100% bezpieczne w zależności od Twojego operatora komórkowego. Możesz zapoznać się z naszymi <a>Zasadami Prywatności Wiadomości</a>, aby uzyskać więcej szczegółów.',
    demographics_consent_body_line2:
      'Dzisiejsza opieka będzie świadczona w ramach telemedycyny (SMS, telefon lub wideo), a nie osobiście. Wyjaśniono ryzyka, korzyści i alternatywy — w tym Twoje prawo do przerwania w dowolnym momencie i skorzystania z opieki stacjonarnej. Twoja prywatność jest chroniona przez prawo, choć żaden system nie jest całkowicie bezpieczny.',
    demographics_consent_body_line3: 'Czy wyrażasz zgodę na komunikację SMS i otrzymanie dziś opieki telemedycznej?',
    demographics_consent_agree: 'Zgadzam się',
    demographics_consent_disagree: 'Nie zgadzam się',
    demographics_consent_footer_prefix: 'Możesz przeczytać naszą',
    demographics_consent_footer_suffix: 'aby uzyskać więcej szczegółów.',

    demographics_confirm_title: 'Potwierdź swoje dane osobowe',

    // Demographics - Minor
    demographics_minor_title: 'Informacje o nieletnim',
    demographics_minor_address_notice:
      'Możemy zarejestrować nieletniego tylko pod tym samym adresem, pod którym obecnie mieszka jego rodzic lub opiekun prawny.',
    demographics_minor_success_body: 'Możesz teraz wrócić do czatu z lekarzem Tap Telehealth.',

    demographics_no_consent_title: 'Nie ma problemu!',
    demographics_no_consent_body_line1:
      'Dziękujemy za informację. Jeśli wolisz nie komunikować się przez SMS, wciąż możesz dziś otrzymać opiekę poprzez nasz Portal Pacjenta zgodny z HIPAA.',
    demographics_no_consent_body_line2: 'Twoja opieka nadal będzie świadczona w ramach telemedycyny zamiast osobiście.',
    demographics_no_consent_body_line3:
      'Czy wyrażasz zgodę na otrzymanie dziś opieki telemedycznej za pośrednictwem Portalu Pacjenta?',
    demographics_no_consent_agree_portal_cta: 'Zgadzam się, przejdź do Portalu Pacjenta',

    demographics_lastword_title: 'Szanujemy Twój wybór!',
    demographics_lastword_body_line1:
      'Rozumiemy i szanujemy Twój wybór. Obecnie Tap Telehealth może świadczyć opiekę wyłącznie w ramach telemedycyny (SMS, telefon lub wideo). Niestety, nie możemy dziś zaoferować wizyt stacjonarnych ani innych alternatywnych usług.',
    demographics_lastword_body_line2:
      'Jeśli chcesz, możesz skontaktować się z nami ponownie, gdy telemedycyna będzie dla Ciebie odpowiednia. W międzyczasie, jeśli potrzebujesz pilnej pomocy medycznej, zadzwoń pod numer 911 lub udaj się na najbliższy oddział ratunkowy.',

    demographics_success_title: 'Wszystko gotowe!',
    demographics_success_body:
      'Dziękujemy za uzupełnienie informacji. Możesz teraz wrócić do czatu z lekarzem Tap Telehealth — są gotowi pomóc. Proszę daj im znać, że wypełniłeś ten formularz.',
    demographics_back_to_chat: 'Powrót do czatu',

    // Intake
    intake_closed_title: 'Ten formularz nie jest już dostępny',
    intake_closed_body: 'Twój lekarz zbierze Twoje dane na czacie.',
    intake_who_title: 'Kto potrzebuje dziś opieki?',
    intake_who_self: 'Ja',
    intake_who_self_description: 'Jestem pacjentem',
    intake_who_child: 'Moje dziecko',
    intake_who_child_description: 'Jestem rodzicem lub opiekunem prawnym i dodam moje dziecko',
    intake_under_18_link: 'Mam mniej niż 18 lat',
    intake_under_18_notice:
      'Możemy udzielać opieki pacjentom poniżej 18 roku życia tylko wspólnie z rodzicem lub opiekunem prawnym. Poproś rodzica lub opiekuna, aby wypełnił ten formularz razem z Tobą, lub aby napisał do nas SMS ze swojego telefonu.',
    intake_under_18_confirm: 'Rozumiem',
    intake_minor_success_title: 'Dziękujemy za informację',
    intake_minor_success_body:
      'Poproś rodzica lub opiekuna, aby był w pobliżu. Lekarz wkrótce skontaktuje się z Tobą w rozmowie SMS.',
    intake_stepper_guardian: 'Rodzic lub opiekun (Ty)',
    intake_stepper_child: 'Twoje dziecko',
    intake_guardian_title: 'Najpierw opowiedz nam o sobie',
    intake_guardian_notice:
      'Krok 1 dotyczy Ciebie. Jako rodzic lub opiekun prawny jesteś właścicielem konta. Dziecko dodasz w następnym kroku.',
    intake_children_title: 'Teraz o Twoim dziecku',
    intake_children_intro:
      'Twoje dziecko będzie miało ten sam numer telefonu i adres zamieszkania co Ty. Udzielona przez Ciebie zgoda obowiązuje w jego imieniu. Wizyta będzie dotyczyć Twojego dziecka.',
    intake_child_heading: 'Dziecko {{number}}',
    intake_child_born: 'ur. {{dob}}',
    intake_remove_child: 'Usuń',
    intake_add_child: 'Dodaj kolejne dziecko',
    intake_visit_for_title: 'Którego dziecka dotyczy ta wizyta?',
    intake_visit_for_required: 'Wybierz, kogo dotyczy ta wizyta',
    intake_confirm_children: 'Dzieci',
    intake_confirm_visit_for: 'Ta wizyta dotyczy',
    intake_confirm_patient: 'Pacjent',
    intake_confirm_guardian: 'Rodzic lub opiekun',
    intake_confirm_children_consent:
      'Jako rodzic lub opiekun prawny udzielone powyżej zgody obejmują również dodane przez Ciebie dzieci.',
    intake_email_in_use: 'Ten adres e-mail jest już używany. Pozostaw pole puste lub wpisz inny.',
    intake_success_body: 'Wróć do rozmowy SMS — lekarz wkrótce się Tobą zajmie.',
    intake_adult_dob_child_hint:
      'Musisz mieć co najmniej 18 lat. Ten formularz dotyczy Ciebie jako osoby dorosłej, która się z nami kontaktuje. Jeśli piszesz w sprawie dziecka, wpisz tutaj swoje dane, a dziecko dodaj w następnym kroku.',

    // Demographics validation
    demographics_validation_first_name_required: 'Imię jest wymagane',
    demographics_validation_last_name_required: 'Nazwisko jest wymagane',
    demographics_validation_email_invalid: 'Proszę podać prawidłowy adres e-mail',
    demographics_validation_dob_required: 'Data urodzenia jest wymagana',
    demographics_validation_dob_format: 'Proszę podać datę w formacie MM/DD/RRRR',
    demographics_validation_dob_month: 'Proszę podać prawidłowy miesiąc',
    demographics_validation_dob_day: 'Proszę podać prawidłowy dzień',
    demographics_validation_dob_year: 'Proszę podać prawidłowy rok',
    demographics_validation_dob_future: 'Data urodzenia nie może być w przyszłości',
    demographics_validation_dob_valid: 'Proszę podać prawidłową datę',
    demographics_validation_gender_required: 'Proszę wybrać płeć',
    demographics_validation_phone_required: 'Numer telefonu jest wymagany',
    demographics_phone: 'Numer telefonu',
    validation_numbers_only: 'Dozwolone są tylko cyfry!',
    demographics_validation_address_required: 'Adres jest wymagany',
    demographics_validation_city_required: 'Miasto jest wymagane',
    demographics_validation_zip_required: 'Kod pocztowy jest wymagany',
    demographics_validation_state_required: 'Stan jest wymagane',
    demographics_validation_address_select: 'Proszę wybrać adres z sugestii',
    demographics_address_placeholder: 'Zacznij wpisywać swój adres...',
    demographics_heard_about_service_label: 'Jak po raz pierwszy dowiedziałeś się o naszej usłudze?',
    demographics_heard_about_service_other: 'Inne (proszę podać)',
    demographics_heard_about_service_friend: 'Przyjaciel lub członek rodziny',
    demographics_heard_about_service_community: 'Wydarzenia społecznościowe',
    demographics_heard_about_service_social: 'Media społecznościowe',
    demographics_heard_about_service_google: 'Google',
    demographics_heard_about_service_specify: 'Proszę podać, jak dowiedziałeś się o naszej usłudze',

    // Patient Portal - Medical History page and related components
    medical_history_title: 'Historia medyczna',
    medical_history_description:
      'Śledź swoją historię medyczną tutaj, zapewniając, że zawsze mamy najnowsze szczegóły, aby zapewnić najbardziej skuteczną opiekę.',
    medical_history_pdf_filename: 'HistoriaMedyczna.pdf',

    title_section_download_pdf: 'Pobierz (PDF)',
    title_section_see_chat: 'Zobacz czat',

    sidebar_medical_history: 'Historia medyczna',
    sidebar_personal_info: 'Informacje osobiste',
    personal_info_general_title: 'Informacje ogólne',

    // Past Sessions
    no_sessions_available: 'Brak dostępnych sesji',
    no_diagnosis_available: 'Brak dostępnej diagnozy',
    past_session_label: 'Poprzednia sesja',
    end_of_chat_title: 'Koniec czatu',
    encounter_closed_message:
      'To spotkanie jest zamknięte. Jeśli potrzebujesz dalszej pomocy, skontaktuj się z lekarzem.',
    connect_me_with_doctor: 'Połącz mnie z lekarzem',
    handouts_title: 'Materiały',
    additional_notes: 'Dodatkowe notatki',
    no_files_available: 'Brak dostępnych plików',
    excuse_notes_title: 'Zwolnienia lekarskie',
    excuse_note_title_work: 'Zwolnienie do pracy',
    excuse_note_title_school: 'Zwolnienie szkolne',
    excuse_note_title_other: 'Zwolnienie',
    excuse_note_open_error: 'Nie udało się otworzyć tego zwolnienia. Spróbuj ponownie.',
    no_excuse_notes_available: 'Brak dostępnych zwolnień',
    prescriptions_title: 'Recepty',
    no_prescriptions_available: 'Brak dostępnych recept',
    referrals_title: 'Skierowania',
    no_referrals_available: 'Brak dostępnych skierowań',
    summary_title: 'Podsumowanie',
    no_data: 'Brak danych',
    no_data_available: 'Brak dostępnych danych',
    no_date_available: 'Brak dostępnej daty',

    // Footer brand heading
    footer_brand_heading: 'TAP TELEHEALTH',

    // Medical History - Allergies Card
    mh_allergies_title: 'Alergie',
    mh_allergies_intro: 'Znajomość Twoich alergii pomaga nam przepisywać dokładniejsze leki i zapobiegać reakcjom.',
    mh_allergies_yesno_question: 'Czy masz jakiekolwiek alergie (na leki, jedzenie itp.)?',
    mh_allergies_none_label: 'Brak znanych alergii',
    mh_allergies_add_btn: 'Dodaj alergię',
    mh_allergies_none_cta: 'Nie mam żadnych alergii',
    mh_allergies_form_name_label: 'Nazwa',
    mh_allergies_form_name_required: 'Proszę wybrać alergię',
    mh_allergies_form_reaction_label: 'Reakcja',
    mh_allergies_reaction_prefix: 'Reakcja',

    // Medical History - Medications Card
    mh_medications_title: 'Leki',
    mh_medications_intro:
      'Znajomość Twoich obecnych leków pomaga nam zapobiegać interakcjom i zapewniać bezpieczniejszą opiekę.',
    mh_medications_yesno_question:
      'Czy obecnie przyjmujesz regularnie jakiekolwiek leki w celu leczenia jakichkolwiek problemów zdrowotnych?',
    mh_medications_none_label: 'Brak obecnych leków',
    mh_medications_add_btn: 'Dodaj lek',
    mh_medications_none_cta: 'Nie biorę żadnych leków regularnie',
    mh_medications_form_drug_label: 'Nazwa leku',
    mh_medications_form_drug_required: 'Proszę wybrać lek',
    mh_medications_form_dosage_label: 'Dawkowanie',
    mh_medications_form_dosage_required: 'Proszę podać dawkowanie',
    mh_medications_form_dosage_placeholder: 'Najpierw wyszukaj lek, aby zmienić dawkowanie.',
    mh_medications_form_frequency_label: 'Częstotliwość',

    // Medical History - Measurements Card
    mh_measurements_title: 'Pomiary',
    mh_measurements_intro: 'Podanie wagi i wzrostu pomaga nam dostosować leczenie i dawkowanie do Twoich potrzeb.',
    mh_measurements_height_label: 'Jaki jest Twój wzrost?',
    mh_measurements_height_feet_required: 'Proszę podać stopy',
    mh_measurements_height_feet_placeholder: 'stopy',
    mh_measurements_height_inches_placeholder: 'cale',
    mh_measurements_weight_label: 'Jaka jest Twoja waga?',
    mh_measurements_weight_required: 'Proszę podać wagę',
    mh_measurements_weight_placeholder: 'kg',
    mh_measurements_view_height: 'Wzrost',
    mh_measurements_view_weight: 'Waga',

    // Medical History - Health Problems Card
    mh_healthproblems_title: 'Problemy zdrowotne',
    mh_healthproblems_intro:
      'Dzielenie się historią medyczną pomaga nam lepiej zrozumieć Twoje zdrowie i zapewnić bardziej spersonalizowaną opiekę.',
    mh_healthproblems_none_label: 'Brak znanych problemów zdrowotnych',
    mh_healthproblems_add_btn: 'Dodaj problem zdrowotny',
    mh_healthproblems_none_cta: 'Nie mam żadnych problemów zdrowotnych',
    mh_healthproblems_other_placeholder: 'Proszę określić...',

    // Medical History - Family History Card
    mh_familyhistory_title: 'Historia rodzinna',
    mh_familyhistory_intro:
      'Zrozumienie medycznej historii rodzinnej pomaga nam ocenić ryzyko zdrowotne i zapewnić proaktywną opiekę.',
    mh_familyhistory_yesno_question:
      'Czy którykolwiek z członków Twojej rodziny ma długotrwałe problemy zdrowotne (takie jak cukrzyca, choroby serca lub inne przewlekłe schorzenia)?',
    mh_familyhistory_none_label: 'Brak znanych problemów rodzinnych',
    mh_familyhistory_add_btn: 'Dodaj historię rodzinną',
    mh_familyhistory_none_cta: 'Nikt w mojej rodzinie nie ma długotrwałych problemów zdrowotnych',
    mh_familyhistory_other_placeholder: 'Proszę określić...',

    // Medical History - Lifestyle Card
    mh_lifestyle_title: 'Styl życia',
    mh_lifestyle_intro:
      'Znajomość Twojego stylu życia pomaga nam zrozumieć czynniki wpływające na Twoje zdrowie i opiekę.',
    mh_lifestyle_smoking_question:
      'Czy obecnie palisz lub vapujesz jakiekolwiek substancje (np. papierosy, e-papierosy lub inne produkty do vapowania)?',
    mh_lifestyle_yes_smoke: 'Tak, palę',
    mh_lifestyle_yes_vape: 'Tak, vapuję',
    mh_lifestyle_yes_both: 'Tak, palę i vapuję',
    mh_lifestyle_drinking_question: 'Czy pijesz alkohol?',
    mh_lifestyle_view_smoking_label: 'Palenie/Vapowanie',
    mh_lifestyle_view_drinking_label: 'Picie alkoholu',
    mh_lifestyle_no_response: 'Brak odpowiedzi',

    // Medical History - Surgical History Card
    mh_surgical_title: 'Historia chirurgiczna',
    mh_surgical_intro:
      'Znajomość historii chirurgicznej pomaga nam unikać komplikacji i zapewniać bezpieczniejsze leczenie.',
    mh_surgical_yesno_question: 'Czy miałeś w przeszłości jakiekolwiek operacje?',
    mh_surgical_none_label: 'Brak operacji',
    mh_surgical_add_btn: 'Dodaj operację',
    mh_surgical_none_cta: 'Nie miałem żadnych operacji w przeszłości',
    mh_surgical_form_surgery_label: 'Operacja',
    mh_surgical_form_surgery_required: 'Proszę wybrać opcję',

    // Patient Portal - Emergency Contacts
    emergency_contacts_title: 'Kontakty alarmowe',
    emergency_contacts_intro:
      'Proszę dodać dane kontaktowe osób, z którymi zezwalasz nam skontaktować się w przypadku nagłej sytuacji.',
    emergency_contacts_add_btn: 'Dodaj kontakt alarmowy',
    relationship: 'Związek',
    validation_select_option: 'Wybierz opcję',

    // Relationship types (from RelationshipType enum)
    relationship_type_emergency_contact: 'Kontakt alarmowy',
    relationship_type_guardian: 'Opiekun',
    relationship_type_next_of_kin: 'Najbliższy krewny',
    relationship_type_caregiver: 'Opiekun medyczny',
    relationship_type_parent: 'Rodzic',
    relationship_type_child: 'Dziecko',
    relationship_type_spouse: 'Małżonek/Małżonka',
    relationship_type_sibling: 'Rodzeństwo',
    relationship_type_mother: 'Matka',
    relationship_type_father: 'Ojciec',
    relationship_type_son: 'Syn',
    relationship_type_daughter: 'Córka',
    relationship_type_grandmother: 'Babcia',
    relationship_type_grandfather: 'Dziadek',
    relationship_type_granddaughter: 'Wnuczka',
    relationship_type_grandson: 'Wnuk',
    relationship_type_aunt: 'Ciocia',
    relationship_type_uncle: 'Wujek',
    relationship_type_niece: 'Siostrzenica/Bratanica',
    relationship_type_nephew: 'Siostrzeniec/Bratanek',
    relationship_type_cousin: 'Kuzyn/Kuzynka',
    relationship_type_legal_guardian: 'Opiekun prawny',
    relationship_type_foster_parent: 'Rodzic zastępczy',
    relationship_type_adoptive_parent: 'Rodzic adopcyjny',
    relationship_type_step_parent: 'Ojczym/Macocha',
    relationship_type_step_son: 'Pasierb',
    relationship_type_step_daughter: 'Pasierbica',
    relationship_type_foster_son: 'Przybrany syn',
    relationship_type_foster_daughter: 'Przybrana córka',
    relationship_type_step_sibling: 'Przyrodnie rodzeństwo',
    relationship_type_in_law: 'Teść/Teściowa/Szwagier/Szwagierka',
    relationship_type_domestic_partner: 'Partner/Partnerka',
    relationship_type_lawyer: 'Prawnik',
    relationship_type_doctor: 'Lekarz',
    relationship_type_therapist: 'Terapeuta',
    relationship_type_social_worker: 'Pracownik socjalny',
    relationship_type_case_manager: 'Koordynator opieki',
    relationship_type_nurse: 'Pielęgniarka/Pielęgniarz',
    relationship_type_neighbor: 'Sąsiad/Sąsiadka',
    relationship_type_coworker: 'Współpracownik/Współpracowniczka',
    relationship_type_roommate: 'Współlokator/Współlokatorka',
    relationship_type_mentor: 'Mentor',
    relationship_type_mentee: 'Podopieczny',
    relationship_type_religious_leader: 'Przywódca religijny',
    relationship_type_volunteer: 'Wolontariusz/Wolontariuszka',
    relationship_type_colleague: 'Kolega/Koleżanka',
    relationship_type_supervisor: 'Przełożony/Przełożona',
    relationship_type_subordinate: 'Podwładny/Podwładna',
    relationship_type_godparent: 'Rodzic chrzestny',
    relationship_type_godchild: 'Chrześniak/Chrześnica',
    relationship_type_ward: 'Podopieczny',
    relationship_type_sponsor: 'Sponsor',
    relationship_type_benefactor: 'Darczyńca',
    relationship_type_friend: 'Przyjaciel/Przyjaciółka',
    relationship_type_acquaintance: 'Znajomy/Znajoma',
    relationship_type_partner: 'Partner/Partnerka',
    relationship_type_other: 'Inny',

    // Minor Guardian Relationship translations
    minor_guardian_relationship_mother: 'Matka',
    minor_guardian_relationship_father: 'Ojciec',
    minor_guardian_relationship_aunt: 'Ciocia',
    minor_guardian_relationship_uncle: 'Wujek',
    minor_guardian_relationship_grandmother: 'Babcia',
    minor_guardian_relationship_grandfather: 'Dziadek',
    minor_guardian_relationship_son: 'Syn',
    minor_guardian_relationship_daughter: 'Córka',
    minor_guardian_relationship_step_son: 'Pasierb',
    minor_guardian_relationship_step_daughter: 'Pasierbica',
    minor_guardian_relationship_step_mother: 'Macocha',
    minor_guardian_relationship_step_father: 'Ojczym',
    minor_guardian_relationship_foster_son: 'Przybrany syn',
    minor_guardian_relationship_foster_daughter: 'Przybrana córka',
    minor_guardian_relationship_foster_mother: 'Rodzina zastępcza - matka',
    minor_guardian_relationship_foster_father: 'Rodzina zastępcza - ojciec',
    minor_guardian_relationship_ward: 'Podopieczny',
    minor_guardian_relationship_grandson: 'Wnuk',
    minor_guardian_relationship_granddaughter: 'Wnuczka',
    minor_guardian_relationship_niece: 'Siostrzenica/Bratanica',
    minor_guardian_relationship_nephew: 'Siostrzeniec/Bratanek',
    minor_guardian_relationship_cousin: 'Kuzyn/Kuzynka',
    minor_guardian_relationship_other: 'Inny',

    // Patient Portal - Pharmacy Step
    pharmacy_search_label: 'Szukaj apteki',
    pharmacy_search_placeholder: 'Szukaj według nazwy, adresu lub kodu pocztowego',

    // Stepper - Completion messages
    stepper_finish_title: 'Wszystko gotowe!',
    stepper_finish_btn_home: 'Wróć do strony głównej',
    stepper_finish_desc:
      'Doceniamy Twój czas i wysiłek włożony w udostępnienie informacji. To pomaga nam zapewnić bezpieczną, spersonalizowaną opiekę i priorytetowo traktować Twoje zdrowie.',
    stepper_close_btn: 'Zamknij',
    stepper_thankyou_title: 'Dziękujemy!',
    stepper_finish_description:
      'Twoje informacje zostały pomyślnie przesłane. Proszę wróć do czatu z lekarzem, aby kontynuować rozmowę i otrzymać dalsze wskazówki.',
    mh_surgical_form_other_label: 'Określ inną operację',
    mh_surgical_form_other_required: 'Proszę określić operację',
    mh_surgical_form_other_placeholder: 'Wpisz nazwę operacji',

    // Medical History - PDF
    pdf_medical_history_title: 'HISTORIA MEDYCZNA',
    pdf_label_gender: 'Płeć',
    pdf_label_dob: 'Data urodzenia',
    pdf_label_height: 'Wzrost',
    pdf_label_weight: 'Waga',
    pdf_label_office: 'Biuro',
    pdf_label_website: 'Strona internetowa',
    pdf_label_email: 'E-mail',
    pdf_past_sessions_title: 'POPRZEDNIE SESJE',

    // Auth - Recover Password
    email_required: 'Proszę podać adres e-mail',
    unknown_error_try_again: 'Nieznany błąd, proszę spróbować ponownie później.',

    // Auth - Send Code / Enter Code / Send Mail
    sendcode_title: 'Twoja bezpośrednia linia do opieki',
    sendcode_description:
      'Wpisz numer telefonu komórkowego, aby otrzymać kod weryfikacyjny SMS. Mogą obowiązywać opłaty operatora.',
    need_assistance: 'Potrzebujesz pomocy?',
    reach_out_at: 'Skontaktuj się z nami pod adresem',
    read_prefix: 'Przeczytaj TapTelehealth',
    terms_and_conditions: 'Warunki i zasady',
    enter_code_title: 'Wpisz swój kod',
    enter_code_phone_sent: 'Wysłaliśmy kod na Twój telefon kończący się na',
    enter_code_email_sent: 'Wysłaliśmy kod na Twój adres e-mail',
    enter_code_enter_below: 'Wpisz go poniżej, aby zweryfikować konto.',
    enter_code_send_new: 'Wyślij nowy kod',
    enter_code_required: 'Proszę podać kod weryfikacyjny',
    enter_code_must_be_6_digits: 'Kod musi składać się z dokładnie 6 cyfr',
    verify_cta: 'Weryfikuj',
    send_code_cta: 'Wyślij kod',
    mobile_phone_number_label: 'Numer telefonu komórkowego',
    must_agree_to_continue: 'Musisz się zgodzić, aby kontynuować',
    messaging_consent_text:
      'Wyrażam zgodę na otrzymywanie wiadomości SMS od Tap Telehealth dotyczących ogólnych informacji zdrowotnych i aktualizacji związanych z usługą. Rozumiem, że mogą obowiązywać opłaty za wiadomości i dane oraz że częstotliwość wiadomości jest różna. Mogę zrezygnować w dowolnym momencie poprzez <portalLink>Portal Pacjenta Tap Telehealth</portalLink> lub odpowiadając STOP na dowolną wiadomość. Dowiedz się więcej w naszych <termsLink>Warunkach Świadczenia Usług</termsLink> i naszej <privacyLink>Polityce Prywatności</privacyLink> lub odpowiadając HELP na dowolną wiadomość.',
    email_consent_text:
      'Wyrażam zgodę na otrzymywanie informacji i aktualizacji związanych ze zdrowiem pocztą elektroniczną.',

    // Auth - Household
    household_where_located_title: 'Gdzie się znajdujesz?',
    household_where_located_desc:
      'Podanie adresu zapewnia, że możemy szybko i łatwo połączyć Cię z odpowiednim lekarzem.',

    // Survey Module - Survey Steps
    survey_info_title: 'Pomóż nam spersonalizować Twoją opiekę',
    survey_info_button: 'Rozpocznij',
    survey_info_description_part1:
      'Zanim ukończymy Twoją receptę, chcielibyśmy zebrać kilka ważnych informacji o zdrowiu. Ten krótki kwestionariusz',
    survey_info_description_part2: 'pomaga nam zapewnić Twoje bezpieczeństwo i najlepszą możliwą opiekę',
    survey_all_done_title: 'Dziękujemy!',
    survey_all_done_description:
      'Twoje informacje zostały pomyślnie przesłane. Wróć do czatu z klinicystą, aby kontynuować rozmowę i otrzymać dalsze wskazówki.',

    // Survey Module - Allergies Card
    survey_allergies_title: 'Alergie',
    survey_allergies_title_minor: 'Alergie nieletniego',
    survey_allergies_question: 'Czy masz jakiekolwiek alergie (leki, jedzenie itp.)?',
    survey_allergies_question_minor: 'Czy Twój nieletni ma jakieś alergie (leki, jedzenie itp.)?',
    survey_allergies_intro:
      'Udostępnienie informacji o alergiach zapewnia bezpieczniejsze recepty i pomaga nam unikać reakcji niepożądanych.',
    survey_allergies_intro_minor:
      'Udostępnienie tych informacji o alergiach zapewnia bezpieczniejsze recepty i pomaga nam unikać reakcji niepożądanych.',
    survey_allergies_no_cta: 'Nie, nie mam żadnych alergii',
    survey_allergies_no_cta_minor: 'Nie, nieletni nie ma żadnych alergii',
    survey_allergies_yes_add: 'Tak, dodaj alergię',
    survey_allergies_form_name_label: 'Nazwa alergii',
    survey_allergies_form_name_required: 'Proszę wybrać alergię',
    survey_allergies_form_reaction_label: 'Reakcja (Zaznacz wszystkie, które dotyczą):',
    survey_allergies_form_other_placeholder: 'Proszę określić',
    survey_allergies_form_other_required: 'Proszę określić reakcję',
    survey_allergies_add_btn: 'Dodaj alergię',
    survey_allergies_confirm_question: 'Czy te informacje o alergiach są poprawne i kompletne?',
    survey_allergies_no_update: 'Nie, muszę dodać alergię',
    survey_allergies_reaction_rash: 'Wysypka/Pokrzywka',
    survey_allergies_reaction_swelling: 'Obrzęk',
    survey_allergies_reaction_breathing: 'Trudności w oddychaniu',
    survey_allergies_reaction_anaphylaxis: 'Anafilaksja',
    survey_allergies_reaction_gastro: 'Objawy żołądkowo-jelitowe',
    survey_allergies_reaction_itching: 'Świąd',
    survey_allergies_reaction_other: 'Inne',

    // Survey Module - Pharmacy Card
    survey_pharmacy_title: 'Wybierz aptekę',
    survey_pharmacy_search_label: 'Szukaj apteki',
    survey_pharmacy_search_placeholder: 'Szukaj po nazwie, adresie lub kodzie pocztowym',
    survey_pharmacy_add_btn: '+ Dodaj',
    survey_pharmacy_confirm_question: 'Czy ta apteka jest poprawna?',
    survey_pharmacy_no_update: 'Nie, muszę zaktualizować moją aptekę',

    // Survey Module - Height Card
    survey_height_title: 'Wzrost',
    survey_height_title_minor: 'Wzrost nieletniego',
    survey_height_label: 'Twój wzrost',
    survey_height_label_minor: 'Wzrost nieletniego',
    survey_height_feet_required: 'Proszę podać stopy',
    survey_height_inches_required: 'Proszę podać cale',

    // Survey Module - Weight Card
    survey_weight_title: 'Waga',
    survey_weight_title_minor: 'Waga nieletniego',
    survey_weight_label: 'Twoja waga (lbs)',
    survey_weight_label_minor: 'Waga nieletniego (lbs)',

    // Survey Module - First Question
    survey_q1_title: 'Opowiedz nam o swoich możliwościach opieki zdrowotnej',
    survey_q1_question: 'Bez Tap Telehealth dzisiaj, jak uzyskał(a)byś opiekę?',
    survey_q1_instruction: 'Wybierz to, co realistycznie dotyczy Twojej sytuacji.',
    survey_q1_option1_title: 'Brak możliwości uzyskania opieki medycznej',
    survey_q1_option1_description:
      'Musiał(a)bym zadzwonić pod 911 z powodu braku transportu, trudności z prowadzeniem samochodu podczas choroby lub problemów z mobilnością.',
    survey_q1_option1_italic: '(Powszechne u wielu pacjentów)',
    survey_q1_option2_title: 'Brak natychmiastowych opcji opieki w pobliżu',
    survey_q1_option2_description:
      'SOR byłby moją jedyną opcją opieki tego samego dnia z powodu czasu, lokalizacji lub potrzeby opieki poza godzinami.',
    survey_q1_option2_italic: '(Najczęstsza sytuacja)',
    survey_q1_option3_title: 'Dostępna opieka doraźna',
    survey_q1_option3_description:
      'Mam transport i mógłbym zapłacić współpłatę 50–145 dolarów, ale obejmowałoby to 1–2 godziny oczekiwania.',
    survey_q1_option4_title: 'Mój lekarz mógłby mnie szybko przyjąć',
    survey_q1_option4_description:
      'Mam lekarza rodzinnego oferującego wizyty tego samego/następnego dnia i objawy mogłyby poczekać.',
    survey_q1_option5_title: 'Poczekał(a)bym',
    survey_q1_option5_description:
      'Próbował(a)bym samodzielnej opieki w domu bez szukania profesjonalnej pomocy medycznej.',

    // Survey Module - Second Question
    survey_q2_title: 'Zaoszczędzony czas',
    survey_q2_info_line1: 'Wizyty medyczne stacjonarne zwykle oznaczają:',
    survey_q2_info_line2: '• 3–4 godziny na wizytę (dojazd + oczekiwanie + wizyta)',
    survey_q2_info_line3: '• Większość osób bierze cały dzień wolnego z pracy/szkoły na wizyty',
    survey_q2_info_line4: '• Bez wczesnego leczenia objawy często trwają o 2–3 dni dłużej',
    survey_q2_question: 'Ile dni pracy/szkoły zaoszczędził Ci Tap Telehealth?',
    survey_q2_option1: '3+ dni (licząc zarówno czas wizyty, jak i szybszą rekonwalescencję)',
    survey_q2_option2: '2 dni (częste, gdy objawy ustępują szybciej dzięki wczesnemu leczeniu)',
    survey_q2_option3: '1 dzień (typowe dla jednej wizyty stacjonarnej)',
    survey_q2_option4: 'Mniej niż 1 dzień',
    survey_q2_option5: 'Nie dotyczy (nie pracuję/nie uczęszczam do szkoły)',

    // Survey Module - Third Question
    survey_q3_title: 'Zaoszczędzony czas',
    survey_q3_subtitle: 'Twoje doświadczenie z naszą usługą',
    survey_q3_info_line1: 'Telemedycyna zazwyczaj oszczędza pacjentom:',
    survey_q3_info_line2: '• 2–4 godziny czasu na dojazd i oczekiwanie',
    survey_q3_info_line3: '• 50–250 dolarów kosztów',
    survey_q3_info_line4: '• Kłopot z organizacją transportu',
    survey_q3_slider1_label: 'Jak bardzo prawdopodobne jest, że polecisz Tap Telehealth?',
    survey_q3_slider1_min: 'Mało prawdopodobne',
    survey_q3_slider1_max: 'Bardzo prawdopodobne',
    survey_q3_slider2_label: 'O ile lepszy był Tap Telehealth niż SOR lub opieka doraźna?',
    survey_q3_slider2_min: 'Wcale nie lepszy',
    survey_q3_slider2_max: 'Zdecydowanie lepszy',
    survey_q3_slider3_label: 'Jak łatwo było korzystać z usługi Tap Telehealth?',
    survey_q3_slider3_min: 'Bardzo trudne',
    survey_q3_slider3_max: 'Bardzo łatwe',
    survey_q3_submit_btn: 'Wyślij',

    // Survey Module - Fourth Question
    survey_q4_title: 'Pokrycie',
    survey_q4_info:
      'Twój koszt wynosi bez względu na to, jak jesteś ubezpieczony - pytamy tylko, aby zrozumieć, do kogo dociera TAP. To jest opcjonalne.',
    survey_q4_question: 'Czy obecnie masz ubezpieczenie zdrowotne lub Medicaid?',
    survey_q4_option1: 'Prywatne / pracodawcy',
    survey_q4_option2: 'Medicaid',
    survey_q4_option3: 'Medicare',
    survey_q4_option4: 'Brak ubezpieczenia w tej chwili',
    survey_q4_option5: 'Wolę nie mówić',

    // Survey Module - Additional Feedback
    survey_feedback_title: 'Dodatkowe uwagi',
    survey_feedback_subtitle:
      'Podziel się wszystkim, co chcesz powiedzieć o swoim doświadczeniu z Tap Telehealth. Twoja opinia pomaga nam ulepszać nasze usługi.',
    survey_feedback_info:
      'Prosimy nie umieszczać żadnych informacji osobistych ani medycznych w swojej opinii, takich jak imiona, dane kontaktowe lub inne informacje, które mogłyby Cię zidentyfikować.',
    survey_feedback_placeholder: 'Twoja opinia',
    survey_feedback_consent:
      'Wyrażam zgodę na publiczne udostępnianie mojej opinii lub recenzji przez Tap Telehealth, na przykład na naszej stronie internetowej lub w mediach społecznościowych, bez żadnych informacji osobistych ani identyfikacyjnych.',
    survey_feedback_submit_btn: 'Wyślij',

    // Survey Module - Savings Card
    survey_savings_title: 'Oto Twoja wizyta w liczbach.',
    survey_savings_subtitle: 'Konserwatywne oszacowanie, ile dzisiaj kosztowałaby Cię wizyta gdzie indziej.',

    // Survey Module - Advocate
    survey_thank_you_title: 'Dziękujemy - to naprawdę pomaga',
    survey_thank_you_text:
      'Twoja szczera opinia pomaga TAP stawać się lepszym dla Ciebie i Twoich sąsiadów. Przekazaliśmy ją zespołowi opieki.',
    survey_advocate_no_medical_care_title: 'Udało Ci się ominąć najdroższą możliwą opcję.',
    survey_advocate_no_care_options_title:
      'Załatwiłeś(aś) wiadomością coś, co zwykle kosztuje $1,500 i całe popołudnie.',
    survey_advocate_urgent_care_title: 'Bez współpłacenia. Bez poczekalni. Bez straconego popołudnia.',
    survey_advocate_doctor_quick_title: 'Masz lekarza, z którym możesz się skontaktować. Wielu sąsiadów tego nie ma.',
    survey_advocate_waited_out_title: 'Nie czekałeś(aś), aż samo przejdzie. To ma większe znaczenie, niż myślisz.',
    survey_advocate_no_medical_care_text:
      'Wiadomość zamiast karetki i SOR-u - to wydatek około $2,000, którego większość rodzin się nie spodziewa, a Ty właśnie go uniknąłeś(aś). Teraz pokaż sąsiadowi, który czuje, że nie ma innej opcji, gdzie są drzwi. To właśnie sprawia, że jesteś jednym z najlepszych ambasadorów {{city}}.',
    survey_advocate_no_medical_care_text_no_city:
      'Wiadomość zamiast karetki i SOR-u - to wydatek około $2,000, którego większość rodzin się nie spodziewa, a Ty właśnie go uniknąłeś(aś). Teraz pokaż sąsiadowi, który czuje, że nie ma innej opcji, gdzie są drzwi.',
    survey_advocate_no_care_options_text:
      'Większość ludzi nie wie, że wiadomość może tyle załatwić - Ty to wiesz. Powiedz więc sąsiadowi, który dziś wieczorem pojechałby na SOR: dwuminutowa wiadomość mogła to rozwiązać. To właśnie sprawia, że jesteś jednym z najlepszych ambasadorów {{city}}.',
    survey_advocate_no_care_options_text_no_city:
      'Większość ludzi nie wie, że wiadomość może tyle załatwić - Ty to wiesz. Powiedz więc sąsiadowi, który dziś wieczorem pojechałby na SOR: dwuminutowa wiadomość mogła to rozwiązać.',
    survey_advocate_urgent_care_text:
      'Ominąłeś(ęłaś) około $115 kosztu i godzinę na plastikowym krześle, bo to dało się rozwiązać wiadomością. Pomnóż to przez całe osiedle, a zobaczysz realne pieniądze, które zostają w {{city}}. Powiedz o tym jednemu sąsiadowi - to właśnie czyni Cię jednym z najlepszych ambasadorów miasta.',
    survey_advocate_urgent_care_text_no_city:
      'Ominąłeś(ęłaś) około $115 kosztu i godzinę na plastikowym krześle, bo to dało się rozwiązać wiadomością. Powiedz o tym jednemu sąsiadowi - to właśnie czyni Cię jednym z najlepszych ambasadorów miasta.',
    survey_advocate_doctor_quick_text:
      'To dla tych, którzy przez coś, co mogłaby rozwiązać wiadomość, trafiają na opiekę doraźną albo SOR. Możesz dać im to, co już masz - wskazać lekarza, o którym nie wiedzieli, że jest dla nich dostępny. To właśnie sprawia, że jesteś jednym z najlepszych ambasadorów {{city}}.',
    survey_advocate_doctor_quick_text_no_city:
      'To dla tych, którzy przez coś, co mogłaby rozwiązać wiadomość, trafiają na opiekę doraźną albo SOR. Możesz dać im to, co już masz - wskazać lekarza, o którym nie wiedzieli, że jest dla nich dostępny.',
    survey_advocate_waited_out_text:
      'To, co zignorujesz we wtorek, może skończyć się wizytą na SOR-ze w sobotę - a Ty tego uniknąłeś(aś). Powiedz teraz sąsiadowi, który wciąż to przeczekuje: dwuminutowa wiadomość może uratować mu weekend spędzony w poczekalni. To właśnie sprawia, że jesteś jednym z najlepszych ambasadorów {{city}}.',
    survey_advocate_waited_out_text_no_city:
      'To, co zignorujesz we wtorek, może skończyć się wizytą na SOR-ze w sobotę - a Ty tego uniknąłeś(aś). Powiedz teraz sąsiadowi, który wciąż to przeczekuje: dwuminutowa wiadomość może uratować mu weekend spędzony w poczekalni.',
    survey_advocate_share_button: 'Podziel się swoim doświadczeniem →',

    // Survey Module - Share
    survey_share_title: 'Podziel się dobrem (i oszczędnościami)!',
    survey_share_subtitle: 'Jedno kliknięcie - Twoja karta i podpis są gotowe.',
    survey_share_caption_heading: 'Twój podpis',
    survey_share_no_medical_care_caption:
      'Nie mogłem(am) dziś dotrzeć do lekarza - więc napisałem(am) i w kilka minut dostałem(am) to, czego potrzebowałem(am). To podróż na SOR/karetkę za około $2,000, której nie musiałem(am) odbyć. Niesamowite, że tak mało osób wie, że {{city}} to ma. 💙 #ADoctorIsJustATapAway',
    survey_share_no_medical_care_caption_no_city:
      'Nie mogłem(am) dziś dotrzeć do lekarza - więc napisałem(am) i w kilka minut dostałem(am) to, czego potrzebowałem(am). To podróż na SOR/karetkę za około $2,000, której nie musiałem(am) odbyć. 💙 #ADoctorIsJustATapAway',
    survey_share_no_care_options_caption:
      'Napisałem(am) do prawdziwego lekarza zamiast siedzieć dziś wieczorem na SOR-ze - odpowiedź i recepta w około 15 minut, bez rachunku na $1,500. Jeśli jesteś w {{city}}, też to masz. 💙 #ADoctorIsJustATapAway',
    survey_share_no_care_options_caption_no_city:
      'Napisałem(am) do prawdziwego lekarza zamiast siedzieć dziś wieczorem na SOR-ze - odpowiedź i recepta w około 15 minut, bez rachunku na $1,500. 💙 #ADoctorIsJustATapAway',
    survey_share_urgent_care_caption:
      'Pominąłem(am) dopłatę za opiekę doraźną i poczekalnię - napisałem(am) do lekarza i po kilku minutach było po wszystkim. Niby drobiazg, ale to się sumuje. Super, że {{city}} to ma. 💙 #ADoctorIsJustATapAway',
    survey_share_urgent_care_caption_no_city:
      'Pominąłem(am) dopłatę za opiekę doraźną i poczekalnię - napisałem(am) do lekarza i po kilku minutach było po wszystkim. Niby drobiazg, ale to się sumuje. 💙 #ADoctorIsJustATapAway',
    survey_share_doctor_quick_caption:
      'Mam lekarza, z którym mogę się skontaktować - a teraz mogę to zrobić wiadomością w kilka minut, w dzień i w nocy. Jeśli nie masz lekarza, do którego możesz dotrzeć, {{city}} daje Ci taką możliwość. 💙 #ADoctorIsJustATapAway',
    survey_share_doctor_quick_caption_no_city:
      'Mam lekarza, z którym mogę się skontaktować - a teraz mogę to zrobić wiadomością w kilka minut, w dzień i w nocy. 💙 #ADoctorIsJustATapAway',
    survey_share_waited_out_caption:
      'Normalnie po prostu bym to przeczekał(a) - zamiast tego napisałem(am) do lekarza i zareagowałem(am) wcześnie. Dwie minuty są lepsze niż weekend fatalnego samopoczucia. {{city}} ma to również dla Ciebie. 💙 #ADoctorIsJustATapAway',
    survey_share_waited_out_caption_no_city:
      'Normalnie po prostu bym to przeczekał(a) - zamiast tego napisałem(am) do lekarza i zareagowałem(am) wcześnie. Dwie minuty są lepsze niż weekend fatalnego samopoczucia. 💙 #ADoctorIsJustATapAway',
    survey_share_label: 'Udostępnij',
    survey_share_facebook: 'Facebook',
    survey_share_x: 'Opublikuj na X',
    survey_share_copy_caption: 'Skopiuj podpis',
    survey_share_save_card: 'Zapisz obraz karty',

    // Medical History Survey Module
    mhs_intro_title: 'Przegląd Twojego zdrowia',
    mhs_intro_description:
      'Odpowiedz na kilka krótkich pytań, abyśmy mogli lepiej zrozumieć Twoje zdrowie i spersonalizować Twoją opiekę.',
    mhs_medications_title: 'Aktualne leki',
    mhs_medications_subtitle:
      'Wymień wszystkie leki, które obecnie przyjmujesz, w tym leki na receptę, bez recepty, witaminy i suplementy',
    mhs_conditions_title: 'Schorzenia',
    mhs_conditions_subtitle: 'Wybierz wszystkie schorzenia, które Cię dotyczą.',
    mhs_add_health_condition: 'Dodaj schorzenie',
    mhs_surgical_title: 'Historia chirurgiczna',
    mhs_surgical_subtitle:
      'Opowiedz nam o wszystkich operacjach i zabiegach, które przeszedłeś/przeszłaś w przeszłości.',
    mhs_add_surgery: 'Dodaj operację',
    mhs_success_title: 'Dziękujemy!',
    mhs_success_description: 'Możesz teraz wrócić do czatu, aby kontynuować rozmowę z lekarzem.',

    // Medical History Survey - UI
    mhs_search_medication_placeholder: 'Szukaj leku',
    mhs_search_condition_placeholder: 'Szukaj schorzenia',
    mhs_search_surgery_placeholder: 'Szukaj zabiegu chirurgicznego',
    mhs_most_common_medications: 'Najczęstsze leki',
    mhs_most_common_conditions: 'Najczęstsze schorzenia',
    mhs_most_common_surgeries: 'Najczęstsze operacje',
    mhs_no_medications: 'Nie przyjmuję żadnych leków',
    mhs_other_medication_not_listed: 'Inny lek niewymieniony na liście',
    mhs_no_conditions: 'Nie mam żadnych schorzeń',
    mhs_other_condition_not_listed: 'Inne schorzenie niewymienione na liście',
    mhs_no_surgeries: 'Nie przeszedłem/przeszłam żadnych operacji',
    mhs_other_surgery_not_listed: 'Inna operacja niewymieniona na liście',
    mhs_validation_select_option: 'Proszę wybrać przynajmniej jedną opcję',
    mhs_medication_type_label: 'Typ:',
    mhs_medication_dose_label: 'Dawka/Stężenie:',
    mhs_medication_frequency_label: 'Jak często:',
    mhs_frequency_once_daily: 'Raz dziennie',
    mhs_frequency_twice_daily: 'Dwa razy dziennie',
    mhs_frequency_three_times_daily: 'Trzy razy dziennie',
    mhs_frequency_four_times_daily: 'Cztery razy dziennie',
    mhs_frequency_as_needed: 'W razie potrzeby',
    mhs_frequency_unknown: 'Nie wiem',

    // Opt Out Module
    optout_title: 'Wniosek o rezygnację z Tap Telehealth',
    optout_description:
      'Proszę wypełnić ten formularz, abyśmy mogli przekazać Twoją prośbę do Działu Rozliczeń Usług Komunalnych Miasta.',
    optout_account_number_label: 'Numer konta usług komunalnych',
    optout_submit_button: 'Wyślij',
    optout_success_title: 'Dziękujemy!',
    optout_success_subtitle:
      'Dziękujemy za przesłanie wniosku. Przekażemy Twoje informacje do Działu Rozliczeń Usług Komunalnych Miasta.',
    optout_error_message: 'Nie możemy przesłać Twojego wniosku w tej chwili. Proszę spróbować ponownie później.',
    optout_account_number_required: 'Proszę wprowadzić numer konta usług komunalnych',

    // Opt In Module
    optin_title: 'Ponowne dołączenie do {{programName}}',
    optin_description_opted_out_on: 'Twoje gospodarstwo domowe zrezygnowało z {{programName}} w dniu {{optedOutDate}}.',
    optin_description_opted_out: 'Twoje gospodarstwo domowe zrezygnowało z {{programName}}.',
    optin_description_address: 'Zapisany adres to {{address}}.',
    optin_description_confirm: 'Jeśli chcesz ponownie dołączyć, zaznacz pole poniżej i wyślij wniosek.',
    optin_members_intro: 'To przywróci dostęp dla:',
    optin_confirm_label: 'Potwierdzam, że chcę ponownie dołączyć',
    optin_link_expired_title: 'Ten link wygasł',
    optin_link_expired_subtitle: 'Napisz do nas ponownie, aby otrzymać nowy.',
    optin_no_household_title: 'Nie znaleziono gospodarstwa domowego',
    optin_no_household_subtitle: 'Nie mogliśmy znaleźć gospodarstwa domowego powiązanego z Twoim rekordem pacjenta.',
    optin_submit_button: 'Wyślij',
    optin_success_title: 'Dziękujemy!',
    optin_success_subtitle: 'Otrzymaliśmy Twój wniosek.',
    optin_error_message: 'Nie możemy przesłać Twojego wniosku w tej chwili. Proszę spróbować ponownie później.',
    optin_already_active_title: 'Nie są wymagane żadne działania',
    optin_already_active_subtitle:
      'Twoje gospodarstwo domowe jest już zapisane lub niedawno złożyło wniosek o aktualizację swojego uczestnictwa.',

    // Demographics form token
    demographics_load_error_title: 'Nie udało się załadować formularza',
    demographics_link_expired_title: 'Ten link wygasł',
    demographics_link_expired_subtitle: 'Napisz do swojego świadczeniodawcy, aby otrzymać nowy.',
    demographics_load_error_subtitle: 'Spróbuj ponownie za chwilę.',
    demographics_wrong_patient:
      'Ten formularz należy do dokumentacji innego pacjenta - skontaktuj się ze swoim świadczeniodawcą',
    demographics_minor_adding_for: 'Dodawanie dziecka dla {{name}}',
    demographics_minor_existing_children: 'Dzieci już zapisane w Twojej dokumentacji',

    // Medical History
    mh_medications_no_update: 'Nie, muszę zaktualizować moje leki',
    mh_conditions_no_update: 'Nie, muszę zaktualizować moje schorzenia',
    mh_surgical_no_update: 'Nie, muszę zaktualizować moją historię chirurgiczną',
    mh_medications_confirm_question: 'Czy te informacje o lekach są poprawne i kompletne?',
    mh_conditions_confirm_question: 'Czy te informacje o schorzeniach są poprawne i kompletne?',
    mh_surgical_confirm_question: 'Czy te informacje o historii chirurgicznej są poprawne i kompletne?',
    mh_conditions_none_label: 'Nie mam żadnych schorzeń',
    mh_none_fallback_label: 'Nie wybrano żadnych elementów',
    mh_allergies_skip: 'Nie mam żadnych alergii',
    mh_minor_allergies_skip: 'Nieletni nie ma żadnych alergii',

    // Lab document
    lab_document_ready_title: 'Twój dokument laboratoryjny jest gotowy',
    lab_document_open: 'Otwórz dokument',
    lab_document_save: 'Zapisz PDF',
    lab_document_expired_title: 'Ten link wygasł',
    lab_document_expired_subtitle: 'Skontaktuj się ze swoim dostawcą, aby otrzymać nowy link.',
    lab_document_missing_title: 'Dokument nie został znaleziony',
    lab_document_missing_subtitle: 'Sprawdź link w swojej wiadomości lub skontaktuj się ze swoim dostawcą.',
    lab_document_error_title: 'Nie udało się załadować dokumentu',
    lab_document_error_subtitle: 'Spróbuj ponownie za chwilę.',

    // Lab visit booking
    lab_visit_ordered_by: 'Badania zlecone przez dr {{name}}',
    lab_visit_ordered_by_care_team: 'Badania zlecone przez Twój zespół medyczny',
    lab_visit_title_choose_location: 'Laboratoria w Twojej okolicy',
    lab_visit_title_your_visit: 'Twoja wizyta w laboratorium',
    lab_visit_title_walk_in: 'Przyjdź bez wizyty - dowolnego dnia',
    lab_visit_fasting_title: 'Ta wizyta wymaga bycia na czczo',
    lab_visit_requisition_link: 'Potrzebujesz zlecenia na papierze? Pobierz PDF',
    lab_visit_retry: 'Spróbuj ponownie',
    lab_visit_not_found_title: 'Nie znaleziono linku',
    lab_visit_not_found_subtitle: 'Sprawdź link w wiadomości lub skontaktuj się z zespołem medycznym.',
    lab_visit_expired_title: 'Ten link wygasł',
    lab_visit_expired_subtitle: 'Napisz do zespołu medycznego, aby otrzymać nowy.',
    lab_visit_expired_sms: 'Napisz do zespołu medycznego',
    lab_visit_rate_limited_title: 'Chwileczkę...',
    lab_visit_rate_limited_subtitle: 'Odczekaj kilka sekund i spróbuj ponownie.',
    lab_visit_searching_near: 'Szukam w okolicy',
    lab_visit_find_locations: 'Znajdź placówki',
    lab_visit_zip_hint: 'Będziesz w tym tygodniu gdzie indziej? Zmień kod ZIP - blisko pracy też jest dobrze.',
    lab_visit_location_distance: '{{miles}} mi',
    lab_visit_location_site_code: 'Placówka {{code}}',
    lab_visit_book_a_time: 'Zarezerwuj termin',
    lab_visit_just_walk_in: 'Przyjdę bez wizyty',
    lab_visit_show_more: 'Pokaż więcej (jeszcze {{count}} w okolicy)',
    lab_visit_locations_empty: 'Brak placówek Quest dla tego kodu ZIP. Spróbuj pobliskiego.',
    lab_visit_locations_error: 'Nie udało się wczytać placówek. Spróbuj ponownie.',
    lab_visit_slots_title: 'Kiedy Ci pasuje?',
    lab_visit_all_locations: 'Wszystkie placówki',
    lab_visit_slot_first: 'Najwcześniej',
    lab_visit_slots_empty: 'Brak wolnych terminów w tej placówce. Spróbuj innej.',
    lab_visit_slots_error: 'Nie udało się wczytać terminów dla tej placówki. Spróbuj ponownie.',
    lab_visit_slot_taken: 'Ten termin właśnie został zajęty - oto aktualne opcje.',
    lab_visit_book_error: 'Nie udało się zarezerwować tego terminu. Spróbuj ponownie.',
    lab_visit_booked_eyebrow: 'Wszystko gotowe',
    lab_visit_booked_when: '{{date}} o {{time}}',
    lab_visit_confirmation_code: 'Kod potwierdzenia {{code}}',
    lab_visit_confirmation_hint: 'W recepcji odnajdą Cię po tym kodzie.',
    lab_visit_bring_photo_id: 'Dokument ze zdjęciem - prawo jazdy wystarczy',
    lab_visit_bring_empty_stomach: 'Pusty żołądek',
    lab_visit_bring_nothing_else: 'To wszystko - żadnych formalności, Twoje zlecenie już jest w ich systemie',
    lab_visit_show_check_in_card: 'Pokaż moją kartę zgłoszenia',
    lab_visit_change_time: 'Zmień termin',
    lab_visit_keep_current_time: 'Zostaw obecny termin',
    lab_visit_cancel_visit: 'Odwołaj wizytę',
    lab_visit_cancel_confirm_title: 'Odwołać tę wizytę?',
    lab_visit_cancel_confirm_description:
      'Czy na pewno chcesz odwołać zarezerwowany termin? Po potwierdzeniu możesz zarezerwować nowy',
    lab_visit_cancel_confirm_keep: 'Zostaw',
    lab_visit_cancel_error: 'Nie udało się odwołać wizyty. Spróbuj ponownie.',
    lab_visit_walk_in_intro:
      'Twoje zlecenie już jest w systemie Quest. Przyjdź, kiedy placówka jest otwarta - wizyta nie jest potrzebna.',
    lab_visit_walk_in_pick_label: 'Twój wybór',
    lab_visit_walk_in_any_location: 'Dowolna placówka Quest',
    lab_visit_walk_in_bring_label: 'Zabierz ze sobą',
    lab_visit_bring_photo_id_label: 'Dokument ze zdjęciem',
    lab_visit_bring_photo_id_detail: 'To wszystko, czego potrzebuje Quest',
    lab_visit_bring_stomach_water: 'Woda jest w porządku; tego dnia nie jedz śniadania',
    lab_visit_bring_stomach_nothing: 'Nie jedz ani nie pij niczego przed wizytą',
    lab_visit_book_a_time_instead: 'Zarezerwuj termin zamiast tego',
    lab_visit_walk_in_error: 'Nie udało się zapisać wizyty bez rezerwacji. Spróbuj ponownie.',
    lab_visit_walk_in_switch_error: 'Nie udało się przejść do rezerwacji terminu. Spróbuj ponownie.',
    lab_visit_check_in_title: 'Pokaż to w recepcji',
    lab_visit_check_in_patient: 'Pacjent',
    lab_visit_check_in_dob: 'Data urodzenia',
    lab_visit_check_in_requisition: 'Zlecenie',
    lab_visit_check_in_confirmation: 'Kod potwierdzenia',
    lab_visit_check_in_you_owe: 'Do zapłaty',
    lab_visit_check_in_error: 'Nie udało się wczytać karty zgłoszenia. Spróbuj ponownie.',
    lab_visit_degraded_eyebrow: 'Rezerwacja online obecnie nie działa',
    lab_visit_degraded_intro: 'System rezerwacji Quest nie odpowiada. Zwykle wraca do działania w ciągu godziny.',
    lab_visit_degraded_good_news:
      '<strong>Dobra wiadomość:</strong> wizyta nie jest Ci potrzebna. Twoje zlecenie już jest w ich systemie - możesz przyjść w każdych godzinach otwarcia.',
    lab_visit_degraded_find_quest: 'Znajdź placówkę Quest',
    lab_visit_degraded_bring_slip: 'Zabierz ze sobą zlecenie na badania.',
    lab_visit_walk_in_instead: 'Przyjdź bez wizyty',
    lab_visit_try_booking_again: 'Spróbuj zarezerwować ponownie',
    lab_visit_upstream_down_notice:
      'System rezerwacji Quest nie odpowiada, więc tej wizyty nie można teraz zmienić ani odwołać. Spróbuj ponownie za kilka minut.',
    lab_visit_error_title: 'Nie udało się wczytać Twojej wizyty w laboratorium',
    lab_visit_error_subtitle: 'Spróbuj ponownie za chwilę.',

    // Visits & notes
    menu_visits_notes: 'Wizyty i notatki',
    visits_notes_title: 'Wizyty i notatki',
    visits_notes_load_more: 'Załaduj więcej',
    visits_notes_practitioner: 'dr {{name}}',
    visits_notes_medications_prescribed_one: '{{count}} przepisany lek',
    visits_notes_medications_prescribed_few: '{{count}} przepisane leki',
    visits_notes_medications_prescribed_many: '{{count}} przepisanych leków',
    visits_notes_medications_prescribed_other: '{{count}} przepisanego leku',
    visits_notes_lab_order: 'Badania krwi',
    visits_notes_filter_all: 'Wszystkie',
    visits_notes_filter_visits: 'Wizyty',
    visits_notes_filter_notes: 'Zwolnienia szkolne i do pracy',
    visits_notes_filter_tests: 'Badania',
    visits_notes_empty_notes: 'Brak zwolnień szkolnych i do pracy do wyświetlenia z wczytanych wizyt',
    visits_notes_empty_tests: 'Brak badań do wyświetlenia z wczytanych wizyt',
    visits_notes_error_title: 'Nie udało się wczytać Twoich wizyt',
    visits_notes_error_subtitle: 'Spróbuj ponownie za chwilę.',

    // Lab results
    menu_savings: 'Oszczędności',
    savings_title: 'Twoje oszczędności',
    savings_subtitle: 'Trochę więcej miejsca na to, co ważne.',
    savings_scope_me: 'Ja',
    savings_scope_household: 'Gospodarstwo domowe',
    savings_period_option_all_time: 'Cały okres',
    savings_period_option_this_month: 'Ten miesiąc',
    savings_period_option_last_month: 'Poprzedni miesiąc',
    savings_period_option_this_year: 'Ten rok',
    savings_period_option_last_year: 'Poprzedni rok',
    savings_period_option_custom: 'Własny zakres',
    savings_period_all_time: 'łącznie',
    savings_period_this_month: 'w tym miesiącu',
    savings_period_last_month: 'w poprzednim miesiącu',
    savings_period_this_year: 'w tym roku',
    savings_period_last_year: 'w poprzednim roku',
    savings_period_custom: '{{from}} – {{to}}',
    savings_total_eyebrow: 'Twoja codzienna wartość',
    savings_total_period: 'Szacowane oszczędności {{period}}',
    savings_total_period_empty: 'Zarejestrowane oszczędności {{period}}',
    savings_empty_title: 'Nie zarejestrowano jeszcze oszczędności',
    savings_empty_subtitle:
      'Gdy zaczniesz korzystać z Tap, wszelkie oszczędności na opiece, receptach, badaniach laboratoryjnych i kontroli wagi pojawią się tu automatycznie.',
    savings_category_prescriptions: 'Oszczędności na receptach',
    savings_category_care: 'Oszczędności na opiece',
    savings_category_labs: 'Oszczędności na badaniach laboratoryjnych',
    savings_category_weight_program: 'Oszczędności na kontroli wagi',
    savings_category_workdays: 'Odzyskane dni pracy',
    savings_count_prescriptions: 'Leki: {{count}}',
    savings_count_care: 'Wizyty: {{count}}',
    savings_count_labs: 'Badania: {{count}}',
    savings_count_weight_program: 'Miesiące opłat za program: {{count}}',
    savings_count_workdays_one: '{{days}} dzień',
    savings_count_workdays_few: '{{days}} dni',
    savings_count_workdays_many: '{{days}} dni',
    savings_count_workdays_other: '{{days}} dnia',
    savings_error_savings_disabled_title: 'Oszczędności są obecnie niedostępne',
    savings_error_savings_disabled_subtitle: 'Spróbuj ponownie później.',
    savings_error_not_found_title: 'Nie znaleźliśmy oszczędności dla tego pacjenta',
    savings_error_not_found_subtitle: 'Spróbuj wybrać innego pacjenta.',
    savings_error_invalid_period_title: 'Ten zakres dat jest nieprawidłowy',
    savings_error_invalid_period_subtitle: 'Wybierz datę początkową nie późniejszą niż data końcowa.',
    savings_error_unknown_title: 'Nie udało się wczytać Twoich oszczędności',
    savings_error_unknown_subtitle: 'Spróbuj ponownie później.',
    savings_drawer_close: 'Zamknij',
    savings_drawer_total_prescriptions: 'Łączne oszczędności na lekach: {{count}}',
    savings_drawer_total_care: 'Łączne oszczędności na wizytach: {{count}}',
    savings_drawer_total_labs: 'Łączne oszczędności na badaniach: {{count}}',
    savings_drawer_total_weight_program: 'Łączne oszczędności za miesiące programu kontroli wagi: {{count}}',
    savings_drawer_total_workdays_one: 'Łączne oszczędności za {{days}} odzyskany dzień pracy',
    savings_drawer_total_workdays_few: 'Łączne oszczędności za {{days}} odzyskane dni pracy',
    savings_drawer_total_workdays_many: 'Łączne oszczędności za {{days}} odzyskanych dni pracy',
    savings_drawer_total_workdays_other: 'Łączne oszczędności za {{days}} odzyskanego dnia pracy',
    savings_drawer_retail_price: 'Cena detaliczna',
    savings_drawer_you_paid: 'Zapłacono',
    savings_drawer_estimated_expenses: 'Szacowane wydatki własne',
    savings_breakdown_title: 'Zestawienie oszczędności',
    savings_breakdown_empty: 'Brak zarejestrowanych oszczędności w tym okresie.',
    savings_column_date: 'Data',
    savings_column_patient: 'Pacjent',
    savings_column_medication: 'Lek',
    savings_column_retail_estimate: 'Szacowana cena detaliczna',
    savings_column_coupon_price: 'Cena z kuponem',
    savings_column_insurance_price: 'Szacowana cena z ubezpieczeniem',
    savings_column_price_used: 'Przyjęta cena',
    savings_column_savings: 'Oszczędność',
    savings_column_care_option: 'Inna forma opieki',
    savings_column_estimated_expenses: 'Szacowane wydatki własne',
    savings_column_lab_test: 'Badanie',
    savings_column_program: 'Program',
    savings_column_workdays: 'Odzyskane dni pracy',
    savings_column_workday_value: 'Szacowana wartość dnia pracy',
    savings_care_option_no_medical_care: '911, karetka i izba przyjęć',
    savings_care_option_no_care_options: 'Wizyta na izbie przyjęć',
    savings_care_option_urgent_care: 'Wizyta w punkcie pilnej pomocy',
    savings_care_option_doctor_quick: 'Wizyta u lekarza podstawowej opieki',
    savings_care_option_waited_out: 'Przeczekanie',
    savings_workdays_value_one: '{{days}} dzień pracy',
    savings_workdays_value_few: '{{days}} dni pracy',
    savings_workdays_value_many: '{{days}} dni pracy',
    savings_workdays_value_other: '{{days}} dnia pracy',
    savings_explainer_title: 'Jak szacujemy Twoje oszczędności',
    savings_explainer_intro:
      'Opieka medyczna, recepty i czas poza pracą potrafią się sumować. Oto jak szacujemy wartość, którą otrzymujesz od Tap, na podstawie Twojej dokumentacji opieki, odpowiedzi w ankietach i porównań cen.',
    savings_explainer_prescriptions_title: 'Oszczędności na receptach',
    savings_explainer_prescriptions_p1:
      'Porównujemy szacowaną cenę detaliczną leku z najniższą dostępną porównywalną ceną z kuponem lub z ubezpieczeniem. Największa potencjalna oszczędność jest doliczana do Twojej sumy.',
    savings_explainer_prescriptions_p2:
      'Ostateczna cena w aptece może być inna. To, że lek został odebrany, nie mówi nam, ile za niego zapłacono, dlatego jest to tylko szacunek.',
    savings_explainer_prescriptions_p3:
      'Na podstawie cen detalicznych i cen z kuponem z raportów kuponowych DoseSpot oraz szacunków ubezpieczeniowych z informacji o świadczeniach receptowych DoseSpot w czasie rzeczywistym.',
    savings_explainer_care_title: 'Oszczędności na opiece',
    savings_explainer_care_p1:
      'W ankiecie mówisz nam, dokąd udałbyś się, gdyby Tap nie był dostępny. Używamy typowego szacunkowego kosztu tej formy opieki, aby obliczyć, ile mogłoby to kosztować.',
    savings_explainer_care_p2:
      'Jeśli wybrano „przeczekanie”, ta wizyta nie zwiększa oszczędności. Jeśli nie udzielono odpowiedzi, pomijamy tę wizytę w obliczeniach.',
    savings_explainer_care_p3: 'Na podstawie odpowiedzi w ankiecie i stałych szacunków Tap dla każdej formy opieki.',
    savings_explainer_labs_title: 'Oszczędności na badaniach laboratoryjnych',
    savings_explainer_labs_p1:
      'Za każde bezpłatne zlecenie badań doliczamy stałą szacowaną oszczędność, gdy wszystkie wyniki są dostępne.',
    savings_explainer_labs_p2:
      'Każde zlecenie liczy się raz, niezależnie od tego, czy obejmuje jedno badanie, czy kilka badań i paneli.',
    savings_explainer_labs_p3:
      'Na podstawie zakończonych zleceń badań w Twojej dokumentacji i stałego szacunku Tap na zlecenie.',
    savings_explainer_weight_program_title: 'Oszczędności na kontroli wagi',
    savings_explainer_weight_program_p1:
      'Doliczamy stałą szacowaną oszczędność za każdy miesiąc kalendarzowy udziału w programie kontroli wagi po rozpoczęciu leczenia.',
    savings_explainer_weight_program_p2:
      'Niepełny miesiąc liczy się jako pełny. Każdy miesiąc jest liczony tylko raz, nawet jeśli okresy udziału się nakładają. Oszczędności na lekach są wliczane do oszczędności na receptach.',
    savings_explainer_weight_program_p3:
      'Na podstawie dat Twojego leczenia i porównawczej miesięcznej opłaty za program.',
    savings_explainer_workdays_title: 'Odzyskane dni pracy',
    savings_explainer_workdays_p1:
      'Ankieta mówi nam, ile czasu pracy udało Ci się odzyskać. Liczymy Twoją odpowiedź jako pół dnia, 1, 2 lub 3 dni, a następnie mnożymy przez stałą wartość dnia pracy.',
    savings_explainer_workdays_p2:
      'Jeśli odzyskany czas dotyczył opieki nad dzieckiem, te dni są przypisywane Tobie jako rodzicowi. W przypadku wspólnej wizyty bierzemy największą zgłoszoną liczbę dni i liczymy ją raz.',
    savings_explainer_workdays_p3:
      'To szacunkowa wartość Twojego czasu, a nie potwierdzony dochód ani otrzymane pieniądze.',
    savings_explainer_workdays_p4:
      'Na podstawie Twoich odpowiedzi w ankiecie. Wartość dnia wynika z mediany tygodniowych zarobków według amerykańskiego Biura Statystyki Pracy, podzielonej przez pięć dni roboczych.',
    menu_lab_results: 'Wyniki badań',
    lab_results_title: 'Wyniki badań',
    lab_results_subtitle:
      'Wszystkie zlecenia złożone przez Ciebie lub Twojego lekarza, od najnowszych. Otwórz jedno, aby zobaczyć badania.',
    lab_results_order_number: 'Zlecenie nr {{number}}',
    lab_results_kind_panel: 'Panel',
    lab_results_kind_individual_tests: 'Pojedyncze badania',
    lab_results_kind_mixed: 'Panel + badania',
    lab_results_ordered_by: 'Zlecone przez dr {{name}}',
    lab_results_ordered_by_you: 'Zlecone przez Ciebie',
    lab_results_ordered_by_care_team: 'Zlecone przez Twój zespół medyczny',
    lab_results_released_on: 'Udostępniono {{date}}',
    lab_results_status_awaiting_visit: 'Oczekuje na wizytę',
    lab_results_status_scheduled: 'Wizyta zarezerwowana',
    lab_results_status_processing: 'Oczekiwanie na wyniki',
    lab_results_status_results_ready: 'Wyniki gotowe',
    lab_results_status_rejected: 'Nie udało się przetworzyć',
    lab_results_status_cancelled: 'Anulowane',
    lab_results_status_expired: 'Wygasło',
    lab_results_status_failed: 'Nie udało się zrealizować',
    lab_results_badge_needs_attention: '{{count}} wymaga uwagi',
    lab_results_badge_worth_a_look: '{{count}} warto sprawdzić',
    lab_results_badge_in_range: 'W normie',
    lab_results_empty: 'Nie ma jeszcze wyników badań. Gdy Twój lekarz zleci badania laboratoryjne, pojawią się tutaj.',
    lab_results_error_title: 'Nie udało się wczytać Twoich wyników badań',
    lab_results_error_subtitle: 'Spróbuj ponownie za chwilę.',

    // Lab results - order details
    lab_results_order_not_found_title: 'Nie znaleziono tego zlecenia',
    lab_results_order_not_found_subtitle:
      'Może należeć do innego pacjenta lub wyniki nie zostały jeszcze udostępnione.',
    lab_results_biomarker_count_one: '{{count}} biomarker',
    lab_results_biomarker_count_few: '{{count}} biomarkery',
    lab_results_biomarker_count_many: '{{count}} biomarkerów',
    lab_results_biomarker_count_other: '{{count}} biomarkera',
    lab_results_test_count_one: '{{count}} badanie',
    lab_results_test_count_few: '{{count}} badania',
    lab_results_test_count_many: '{{count}} badań',
    lab_results_test_count_other: '{{count}} badania',
    lab_results_group_in_range: 'W normie',
    lab_results_group_worth_a_look: 'Warto sprawdzić',
    lab_results_group_other: 'Inne',
    lab_results_group_needs_attention: 'Wymaga uwagi',
    lab_results_test_status_pending: 'Oczekuje',
    lab_results_test_status_final: 'Wyniki otrzymane',
    lab_results_test_status_corrected: 'Skorygowane',
    lab_results_test_status_not_performed: 'Nie wykonano',
    lab_results_update_pending:
      'Laboratorium skorygowało jeden z tych wyników i Twój lekarz sprawdza tę zmianę. To, co tu widzisz, może zostać zaktualizowane.',
    lab_results_report_download: 'Pobierz (PDF)',
    lab_results_report_filename: 'lab-report-{{number}}.pdf',
    lab_results_report_error: 'Nie udało się pobrać Twojego raportu. Spróbuj ponownie.',
    lab_results_note_title: 'Notatka kliniczna',
    lab_results_note_author: 'dr {{name}}',
    lab_results_note_empty: 'Brak notatki. Twój lekarz sprawdził te wyniki i udostępnił je bez komentarza.',
    lab_results_chip_all: 'Wszystkie ({{count}})',
    lab_results_filter_empty: 'Żaden wynik nie odpowiada wybranemu filtrowi.',
    lab_results_attention_eyebrow: 'Wymaga uwagi teraz',
    lab_results_attention_title_single: 'Jeden wynik wymaga natychmiastowej opieki',
    lab_results_attention_title_multiple: '{{count}} wyników wymaga natychmiastowej opieki',
    lab_results_attention_reference: '(zakres referencyjny laboratorium {{reference}})',
    lab_results_attention_eyebrow_soon: 'Skontaktuj się wkrótce z lekarzem',
    lab_results_attention_title_single_soon: 'Jeden wynik wymaga uwagi wkrótce',
    lab_results_attention_title_multiple_soon: '{{count}} wyników wymaga uwagi wkrótce',
    lab_results_attention_no_guide:
      'Laboratorium oznaczyło ten wynik jako krytyczny. Twój lekarz skontaktuje się z Tobą.',
    lab_safety_net_emergency: 'Zadzwoń pod 911 lub zgłoś się na SOR, jeśli',
    lab_safety_net_same_day: 'Zgłoś się dzisiaj do lekarza, jeśli',
    lab_results_text_doctor: 'Napisz do lekarza Tap',
    lab_results_attention_hours: 'Wiadomości Tap od 7:00 do 22:00. Wiadomości nie zastępują natychmiastowej opieki.',
    lab_results_ask_doctor_note: 'Masz pytania o to zlecenie? Twój lekarz widzi ten wynik obok Twojej wiadomości.',
    lab_results_ask_doctor_cta: 'Zapytaj lekarza Tap',
    lab_results_state_waiting_title: 'Oczekiwanie na wyniki',
    lab_results_state_waiting_body:
      'Twoja próbka jeszcze nie dotarła do laboratorium. Większość wyników pojawia się w ciągu 2-3 dni po wizycie; wyślemy Ci wiadomość, gdy będą gotowe.',
    lab_results_state_processing_title: 'Oczekiwanie na wyniki',
    lab_results_state_processing_body:
      'Twoja próbka jest w laboratorium. Większość wyników pojawia się w ciągu 2-3 dni po wizycie; wyślemy Ci wiadomość, gdy będą gotowe.',
    lab_results_state_partial_title: 'Część wyników jest już w drodze',
    lab_results_state_partial_body:
      'Część Twoich wyników już dotarła, a pozostałe są jeszcze w laboratorium. Wyślemy Ci wiadomość, gdy wszystkie będą gotowe.',
    lab_results_state_rejected_title: 'Nie udało się przetworzyć tego zlecenia',
    lab_results_state_rejected_body:
      'Laboratorium nie mogło przyjąć tego zlecenia. Twój lekarz skontaktuje się z Tobą.',
    lab_results_state_cancelled_title: 'To zlecenie zostało anulowane',
    lab_results_state_cancelled_body: 'To zlecenie nie przyniesie żadnych wyników.',
    lab_results_state_expired_title: 'To zlecenie wygasło',
    lab_results_state_expired_body:
      'Nie pobrano próbki w wymaganym czasie. Twój lekarz może zlecić te badania ponownie.',
    lab_results_state_failed_title: 'Nie udało się zrealizować tego zlecenia',
    lab_results_state_failed_body: 'To zlecenie nie przyniesie żadnych wyników. Twój lekarz skontaktuje się z Tobą.',

    // Lab results - biomarker details
    lab_marker_not_found_title: 'Nie znaleziono tego wyniku',
    lab_marker_not_found_subtitle: 'Może należeć do innego pacjenta lub nie został jeszcze udostępniony.',
    lab_marker_result: 'Twój wynik',
    lab_marker_result_on: 'Twój wynik · {{date}}',
    lab_marker_reference_caption:
      'Zakres referencyjny laboratorium {{reference}}. Zakres pochodzi z tego raportu. To nie to samo co próg pilny lub krytyczny.',
    lab_marker_reference_plain: 'Zakres referencyjny laboratorium {{reference}}',
    lab_marker_meaning_title: 'Co oznacza Twój wynik',
    lab_marker_next_step_title: 'Co powinnam lub powinienem teraz zrobić?',
    lab_marker_why_this_matters: 'Dlaczego to ważne',
    lab_marker_ask_doctor_note: 'Masz pytania o ten wynik? Twój lekarz widzi ten wynik obok Twojej wiadomości.',
    lab_marker_content_pending: 'Lekarze Tap sprawdzają wyjaśnienie tego wyniku.',
    lab_marker_action_eyebrow: 'Podejmij działanie teraz',
    lab_marker_variants_title: 'Czy coś z tego Ciebie dotyczy?',
    lab_marker_variants_subtitle:
      'Wybierz jedną opcję, a wyjaśnienie poniżej zostanie dopasowane do tej sytuacji. Twój wynik się nie zmienia.',
    lab_marker_variants_adjusted: 'Wyjaśnienie dopasowane do: {{label}}',
    lab_marker_variant_female_pregnant: 'Jestem w ciąży',
    lab_marker_variant_postmenopausal: 'Po menopauzie',

    // Lab results - order history
    lab_results_history_title: 'Historia zlecenia',
    lab_results_history_progress: '{{done}} z {{total}} kroków',
    lab_results_history_ordered: 'Zlecenie złożone',
    lab_results_history_ordered_by: 'Zlecone przez dr {{name}}',
    lab_results_history_ordered_by_you: 'Zlecone przez Ciebie',
    lab_results_history_ordered_by_care_team: 'Zlecone przez Twój zespół medyczny',
    lab_results_history_ordered_detail_add_ons_one: '{{panels}} + {{count}} badanie dodatkowe',
    lab_results_history_ordered_detail_add_ons_few: '{{panels}} + {{count}} badania dodatkowe',
    lab_results_history_ordered_detail_add_ons_many: '{{panels}} + {{count}} badań dodatkowych',
    lab_results_history_ordered_detail_add_ons_other: '{{panels}} + {{count}} badania dodatkowego',
    lab_results_history_sent_to_lab: 'Wysłane do Quest Diagnostics',
    lab_results_history_sent_detail: 'Zlecenie gotowe, post nie jest wymagany',
    lab_results_history_sent_detail_fasting: 'Zlecenie gotowe, wymagany post',
    lab_results_history_visit_scheduled: 'Wizyta zarezerwowana',
    lab_results_history_visit_scheduled_next: 'Zarezerwuj wizytę',
    lab_results_history_visit_detail_next: 'Wybierz placówkę Quest i godzinę lub przyjdź bez wizyty w dowolny poranek',
    lab_results_history_sample_collected: 'Próbka pobrana',
    lab_results_history_collected_walk_in: 'Wizyta bez rezerwacji w {{location}}',
    lab_results_history_collected_at: 'Pobrano w {{location}}',
    lab_results_history_results_partial: 'Część wyników gotowa',
    lab_results_history_results_partial_detail: '{{resulted}} z {{total}} badań z wynikiem',
    lab_results_history_results_final: 'Wszystkie wyniki gotowe',
    lab_results_history_results_final_next: 'Wyniki',
    lab_results_history_results_final_detail: '{{tests}}, {{biomarkers}}',
    lab_results_history_results_final_detail_next: 'Zwykle 2-3 dni po wizycie. Wyślemy Ci wiadomość, gdy będą gotowe',
    lab_results_history_provider_review: 'Sprawdzone przez Twojego lekarza',
    lab_results_history_reviewed_by: 'Sprawdzone przez dr {{name}}',
    lab_results_history_provider_review_next: 'Weryfikacja lekarza',
    lab_results_history_provider_review_detail: 'Nie trzeba nic robić',
    lab_results_history_results_released: 'Udostępnione Tobie',
    lab_results_history_results_released_next: 'Wyniki udostępnione',
    lab_results_history_results_released_detail: 'Wiadomość SMS wysłana',

    // Free labs signup
    free_labs_eyebrow: 'Bezpłatne badania · Opłacone przez Tap · 0 $ dla Ciebie',
    free_labs_community: 'Społeczność: {{name}}',
    free_labs_community_batavia: 'Batavia, IL',
    free_labs_community_aurora: 'Aurora, IL',
    free_labs_community_rolling_meadows: 'Rolling Meadows, IL',
    free_labs_title_phone: 'Bezpłatne badania laboratoryjne dla mieszkańców',
    free_labs_title_code: 'Wpisz kod, który wysłaliśmy SMS-em',
    free_labs_title_picker: 'Kto dziś składa zamówienie?',
    free_labs_title_form_new: 'Opowiedz nam o sobie',
    free_labs_title_form_returning: 'Witaj ponownie, {{name}}',
    free_labs_session_expired: 'Sesja wygasła. Zweryfikuj ponownie numer telefonu, aby kontynuować.',
    free_labs_unavailable_title: 'Bezpłatne badania są obecnie niedostępne',
    free_labs_unavailable_subtitle: 'Spróbuj ponownie później.',
    free_labs_error_generic: 'Coś poszło nie tak. Spróbuj ponownie.',
    free_labs_error_rate_limited: 'Za dużo prób. Odczekaj kilka minut i spróbuj ponownie.',
    free_labs_error_send_failed: 'Nie udało się wysłać kodu. Spróbuj ponownie.',
    free_labs_phone_intro:
      'Zamierzasz zamówić bezpłatny panel badań krwi. Laboratorium wymaga zweryfikowanego numeru telefonu komórkowego, zanim złożymy zamówienie. Wyślemy Ci SMS-em 6-cyfrowy kod.',
    free_labs_phone_note: 'Jeden panel na osobę. Ubezpieczenie nie ma wpływu na uprawnienia.',
    free_labs_phone_label: 'Numer telefonu komórkowego',
    free_labs_phone_required: 'Wpisz numer telefonu komórkowego',
    free_labs_phone_invalid: 'Wpisz prawidłowy amerykański numer telefonu komórkowego',
    free_labs_phone_cta: 'Wyślij mi kod',
    free_labs_phone_footer: 'Mogą obowiązywać opłaty za wiadomości. Na ten numer wyślemy link do rezerwacji i wyniki.',
    free_labs_code_sent_to: 'Wysłano na <strong>{{phone}}</strong>.',
    free_labs_code_change_number: 'Zmień numer',
    free_labs_code_cta: 'Zweryfikuj',
    free_labs_code_resend_prompt: 'Nie dotarł?',
    free_labs_code_resend: 'Wyślij kod ponownie',
    free_labs_code_resent: 'Wysłaliśmy nowy kod.',
    free_labs_code_invalid: 'Ten kod jest nieprawidłowy. Sprawdź wiadomość i spróbuj ponownie.',
    free_labs_code_expired: 'Ten kod wygasł. Poproś o nowy.',
    free_labs_picker_intro:
      'Z tego numeru korzysta więcej niż jedna dorosła osoba w Twoim gospodarstwie domowym. Wybierz siebie, abyśmy mogli uzupełnić Twoje dane.',
    free_labs_picker_born: 'Ur. {{year}}',
    free_labs_picker_unnamed: 'Członek gospodarstwa domowego',
    free_labs_picker_order_placed: 'Zamówienie złożone',
    free_labs_picker_footnote:
      'Nie ma Cię na liście? Znany numer może zapisać tylko dorosłych już na nim zarejestrowanych. Użyj własnego numeru telefonu.',
    free_labs_picker_cta: 'Dalej',
    free_labs_picker_not_on_phone:
      'Nie udało się wczytać danych tej osoby. Wybierz ponownie lub użyj własnego numeru telefonu.',
    free_labs_last_request_title: 'Twoje zgłoszenie z {{date}} nie zostało zrealizowane',
    free_labs_last_request_outside_city:
      'Adres był poza granicami miasta objętego programem. Jeśli się przeprowadziłeś lub adres był błędny, popraw go poniżej i wyślij ponownie.',
    free_labs_last_request_quota_full:
      'Wszystkie bezpłatne panele w tej społeczności były wówczas wykorzystane. Możesz wysłać zgłoszenie ponownie poniżej.',
    free_labs_last_request_duplicate:
      'Bezpłatny panel dla tej osoby został już zamówiony. Sprawdź SMS-y, aby znaleźć link do rezerwacji lub wyniki.',
    free_labs_last_request_address_unresolved:
      'Nie udało się zlokalizować adresu na mapie. Wybierz go z podpowiedzi poniżej i wyślij ponownie.',
    free_labs_last_request_order_failed:
      'Laboratorium nie przyjęło zamówienia. Nasz zespół został powiadomiony; możesz wysłać zgłoszenie ponownie poniżej.',
    free_labs_last_order_title: 'Twoje zamówienie z {{date}} nie jest już aktywne',
    free_labs_last_order_expired: 'Skierowanie wygasło przed pobraniem próbki. Sprawdź dane i wyślij ponownie poniżej.',
    free_labs_last_order_cancelled: 'Zamówienie zostało anulowane. Sprawdź dane i wyślij ponownie poniżej.',
    free_labs_last_order_rejected: 'Laboratorium nie przyjęło zamówienia. Sprawdź dane i wyślij ponownie poniżej.',
    free_labs_last_order_failed: 'Laboratorium nie przyjęło zamówienia. Sprawdź dane i wyślij ponownie poniżej.',
    free_labs_need_email_title: 'Potrzebujemy Twojego adresu e-mail',
    free_labs_need_email_body:
      'Laboratorium wysyła instrukcje dotyczące pobrania próbki e-mailem. Nie mamy jeszcze prawidłowego adresu.',
    free_labs_dob_hint: 'Musisz mieć co najmniej 18 lat.',
    free_labs_sex: 'Płeć',
    free_labs_sex_hint: 'Wymagane przez laboratorium do zakresów referencyjnych.',
    free_labs_email_required: 'Adres e-mail jest wymagany',
    free_labs_email_taken: 'Ten adres e-mail należy do innego pacjenta. Użyj innego.',
    free_labs_phone_taken: 'Ten numer telefonu należy do innego pacjenta. Skontaktuj się z nami.',
    free_labs_phone_verified: 'Zweryfikowany',
    free_labs_address: 'Adres domowy',
    free_labs_address_required: 'Wybierz adres z podpowiedzi',
    free_labs_address_change: 'Zmień',
    free_labs_consents_legend: 'Potwierdź',
    free_labs_consent_required: 'Zaznacz to pole, aby kontynuować',
    free_labs_consent_attestation: 'Mam co najmniej 18 lat i mieszkam pod powyższym adresem.',
    free_labs_consent_sms:
      'Tap może wysyłać mi SMS-y dotyczące mojego zamówienia i wyników badań. Mogą obowiązywać opłaty za wiadomości. W każdej chwili odpowiedz STOP.',
    free_labs_consent_hipaa:
      'Akceptuję <telehealth>zgodę na telemedycynę</telehealth>, <terms>warunki korzystania</terms> i <privacy>politykę prywatności</privacy>.',
    free_labs_form_not_on_phone: 'Ta osoba nie jest zarejestrowana pod Twoim numerem telefonu.',
    free_labs_submit_cta: 'Złóż bezpłatne zamówienie',
    free_labs_ordered_title: 'Twoje bezpłatne zamówienie na badania zostało złożone',
    free_labs_ordered_subtitle:
      'Wyniki otrzymasz SMS-em lub skontaktuje się z Tobą lekarz Tap, aby je omówić. Link do rezerwacji wyślemy też na <strong>{{phone}}</strong>.',
    free_labs_ordered_waiting_title: 'Czekamy na potwierdzenie zamówienia przez laboratorium…',
    free_labs_ordered_waiting_body:
      'To zwykle trwa chwilę. Możesz też zamknąć tę stronę: link do rezerwacji przyjdzie SMS-em.',
    free_labs_ordered_texted_title: 'Wyślemy Ci link do rezerwacji SMS-em',
    free_labs_ordered_texted_body:
      'Laboratorium wciąż potwierdza zamówienie. Gdy to zrobi, link do rezerwacji wizyty przyjdzie SMS-em.',
    free_labs_book_visit: 'Zarezerwuj wizytę w laboratorium',
    free_labs_book_visit_caption:
      'To ten sam link, który wysłaliśmy SMS-em. Wyniki przyjdą SMS-em lub skontaktuje się z Tobą lekarz Tap.',
    free_labs_already_title: 'Cześć {{name}}, wszystko gotowe',
    free_labs_already_title_unnamed: 'Wszystko gotowe',
    free_labs_already_subtitle:
      'Złożyliśmy Twoje bezpłatne zamówienie na badania {{date}}. Jeden panel na osobę, więc nie trzeba nic więcej wysyłać.',
    free_labs_already_book:
      'To ten sam link, który wysłaliśmy SMS-em. Wyniki przyjdą SMS-em lub skontaktuje się z Tobą lekarz Tap.',
    free_labs_already_awaiting_requisition:
      'Laboratorium nie wystawiło jeszcze skierowania. Wkrótce wyślemy Ci link do rezerwacji SMS-em.',
    free_labs_already_results_pending: 'Próbka została pobrana. Wyślemy SMS, gdy wyniki będą gotowe.',
    free_labs_already_released: 'Wyniki zostały wysłane SMS-em. Sprawdź wiadomości, aby znaleźć link do wyników.',
    free_labs_declined_outside_city_title: 'Ten adres jest poza obszarem programu',
    free_labs_declined_outside_city_body:
      'Bezpłatne panele są dla mieszkańców w granicach miast Batavia, Aurora lub Rolling Meadows. Podany adres znajduje się poza nimi. Jeśli jest błędny, wróć i wybierz adres ponownie.',
    free_labs_declined_quota_full_title: 'Wszystkie bezpłatne panele w Twojej okolicy zostały wykorzystane',
    free_labs_declined_quota_full_title_named: 'Wszystkie bezpłatne panele dla {{name}} zostały wykorzystane',
    free_labs_declined_quota_full_body:
      'Program obejmuje ograniczoną liczbę mieszkańców i ten limit został osiągnięty. Zachowaliśmy Twoje dane.',
    free_labs_declined_duplicate_title: 'Bezpłatny panel został już dla Ciebie zamówiony',
    free_labs_declined_duplicate_body:
      'Jeden panel na osobę, więc nie trzeba nic więcej wysyłać. Sprawdź SMS-y, aby znaleźć link do rezerwacji lub wyniki.',
    free_labs_declined_address_unresolved_title: 'Nie udało się zlokalizować Twojego adresu na mapie',
    free_labs_declined_address_unresolved_body:
      'Wybierz adres z podpowiedzi, abyśmy mogli sprawdzić, czy znajduje się w obszarze programu.',
    free_labs_declined_order_failed_title: 'Nie udało się złożyć zamówienia',
    free_labs_declined_order_failed_body:
      'Coś poszło nie tak po stronie laboratorium. Nasz zespół został powiadomiony i wyśle SMS na {{phone}}, aby dokończyć zamówienie. Nie musisz nic robić.',
    free_labs_fix_address: 'Popraw mój adres',

    // Weight program (Foundayo)
    menu_weight_program: 'Program kontroli wagi',
    weight_program_brand: 'Program wagowy',

    weight_program_intro_title: 'Foundayo w kontroli wagi',
    weight_program_intro_body:
      'Foundayo (orforglipron) to tabletka przyjmowana codziennie razem z planem żywieniowym i aktywnością fizyczną. Odpowiedz na 10 krótkich pytań, aby lekarz Tap ocenił, czy może być odpowiednia dla Ciebie.',
    weight_program_intro_how_label: 'Jak to działa',
    weight_program_intro_how_value: '10 pytań → ocena lekarza → decyzja',
    weight_program_intro_takes_label: 'Czas',
    weight_program_intro_takes_value: 'Około 5 minut',
    weight_program_intro_cost_label: 'Koszt oceny',
    weight_program_intro_cost_value: 'Wliczony w opiekę Tap',
    weight_program_intro_disclaimer:
      'Wypełnienie formularza nie gwarantuje recepty. Gdy potrzebujesz pomocy, możesz wybrać „Nie jestem pewien”. Koszt leku i dostępność w aptece omówisz z lekarzem.',
    weight_program_intro_start: 'Rozpocznij',
    weight_program_intro_start_failed: 'Nie udało się rozpocząć programu. Spróbuj ponownie.',
    weight_program_how_title: 'Jak działa program',
    weight_program_how_step_review:
      'Lekarz sprawdza Twój formularz początkowy, potwierdza pomiary i historię odżywiania, ustala z Tobą cel zdrowotny i zatwierdza plan.',
    weight_program_how_step_first_dose:
      'Potwierdzasz dzień przyjęcia pierwszej tabletki, a później dzień rozpoczęcia każdej nowej dawki. Lekarz może skontaktować się z Tobą 1–2 tygodnie po rozpoczęciu lub zmianie dawki, a wcześniej, jeśli coś Cię niepokoi.',
    weight_program_how_step_monthly:
      'Mniej więcej raz w miesiącu otrzymasz krótki formularz kontrolny wraz z przypomnieniami, jeśli nie zostanie wypełniony.',
    weight_program_how_step_changes:
      'Lekarz sprawdza każdy formularz kontrolny przed jakąkolwiek zmianą recepty. Jeśli pominiesz pytanie, zespół opieki skontaktuje się z Tobą.',
    weight_program_how_step_goal:
      'Osiągnięcie celu rozpoczyna rozmowę o utrzymaniu efektów. Jeśli lek zostanie odstawiony, lekarz ustala dalszą obserwację i sposób powrotu do opieki.',

    weight_program_consent_title: 'Zanim zaczniesz',
    weight_program_consent_body_review:
      'Twoje odpowiedzi są zapisywane w Twojej karcie Tap i sprawdzane przez lekarza Tap. Tap używa narzędzi AI, aby uporządkować odpowiedzi dla lekarza; AI nie podejmuje decyzji dotyczących leczenia. O kwalifikacji, receptach i wszelkich zmianach decyduje Twój lekarz.',
    weight_program_consent_body_sms:
      'Comiesięczne formularze kontrolne są częścią tego programu. Mniej więcej raz w miesiącu wyślemy Ci SMS-em link do krótkiego formularza, wraz z przypomnieniami, jeśli nie zostanie wypełniony.',
    weight_program_consent_ai_and_doctor_review:
      'Rozumiem, że lekarz sprawdza moje odpowiedzi i podejmuje wszystkie decyzje dotyczące leczenia, a AI służy wyłącznie do porządkowania informacji.',
    weight_program_consent_program_sms:
      'Zgadzam się na otrzymywanie wiadomości SMS dotyczących tego programu, w tym linków do comiesięcznych formularzy kontrolnych i przypomnień.',
    weight_program_consent_continue: 'Dalej',
    weight_program_consent_accepted_on: 'Zgoda wyrażona {{date}}.',
    weight_program_consent_failed: 'Nie udało się zapisać Twoich zgód. Spróbuj ponownie.',

    weight_program_submitted_title: 'Dziękujemy. Twoje odpowiedzi trafiły do lekarza.',
    weight_program_submitted_body:
      'Lekarz Tap je sprawdzi i poinformuje Cię o kolejnym kroku. Ten formularz nie zatwierdza recepty.',
    weight_program_submitted_status_label: 'Status',
    weight_program_submitted_status_value: 'Oczekuje na ocenę lekarza',
    weight_program_submitted_sent_label: 'Wysłano',
    weight_program_submitted_answers_title: 'Twoje odpowiedzi',

    weight_program_eyebrow: 'Pierwsze kroki',
    weight_program_progress_label: 'Twój postęp',
    weight_program_question_counter: 'Pytanie {{current}} z {{total}}',
    weight_program_review_title: 'Sprawdź swoje odpowiedzi',
    weight_program_review_helper:
      'Przed wysłaniem możesz wrócić i wszystko zmienić. Po wysłaniu lekarz sprawdza te odpowiedzi; zmiany zgłaszasz przez czat.',
    weight_program_review_back: 'Wróć do pytań',
    weight_program_submit: 'Wyślij',
    weight_program_not_answered: 'Brak odpowiedzi',
    weight_program_height_label: 'Twój wzrost',
    weight_program_weight_label: 'Twoja waga',
    weight_program_measured_on_label: 'Kiedy wykonano pomiar?',
    weight_program_problem_missing: 'Odpowiedz na to pytanie, aby kontynuować.',
    weight_program_problem_choose_one: 'Wybierz jedną opcję.',
    weight_program_problem_exclusive_option: 'Tej opcji nie można łączyć z pozostałymi.',
    weight_program_problem_measurements_incomplete: 'Podaj wzrost, wagę i datę.',
    weight_program_problem_measured_on_in_future: 'Data nie może być przyszła.',
    weight_program_problem_detail_required: 'Wypisz swoje leki i suplementy.',
    weight_program_flag_title_emergency: 'Wezwij pomoc teraz',
    weight_program_flag_title_poison_control: 'Zadzwoń teraz do Centrum Zatruć (Poison Control): 1-800-222-1222.',
    weight_program_flag_title_same_day: 'Twój zespół opieki skontaktuje się z Tobą dzisiaj.',
    weight_program_problem_inconsistent: 'Liczba dni z rzędu nie może być większa niż łączna liczba pominiętych dni.',
    weight_program_save_failed: 'Nie udało się zapisać odpowiedzi. Sprawdź połączenie i spróbuj ponownie.',
    weight_program_submit_failed: 'Nie udało się wysłać odpowiedzi. Spróbuj ponownie.',
    weight_program_load_failed: 'Nie udało się wczytać formularza. Spróbuj ponownie.',
    weight_program_option_yes: 'Tak',
    weight_program_option_no: 'Nie',
    weight_program_option_not_sure: 'Nie jestem pewien/pewna',
    weight_program_option_none: 'Żadne z powyższych',
    weight_program_helper_choose_all: 'Zaznacz wszystkie, które pasują.',
    weight_program_body_measurements_title: 'Ile masz wzrostu i ile ważysz?',
    weight_program_body_measurements_helper: 'Podaj niedawno zmierzoną wartość.',
    weight_program_weight_related_conditions_title: 'Czy lekarz stwierdził u Ciebie któreś z poniższych?',
    weight_program_weight_related_conditions_option_hypertension: 'Nadciśnienie',
    weight_program_weight_related_conditions_option_high_cholesterol: 'Wysoki cholesterol',
    weight_program_weight_related_conditions_option_type_2_diabetes: 'Cukrzyca typu 2',
    weight_program_weight_related_conditions_option_sleep_apnea: 'Bezdech senny',
    weight_program_weight_related_conditions_option_heart_disease: 'Choroba serca',
    weight_program_reproductive_status_title: 'Czy któreś z poniższych dotyczy Ciebie?',
    weight_program_reproductive_status_option_pregnant_or_possible: 'Jestem w ciąży lub mogę być w ciąży',
    weight_program_reproductive_status_option_planning_pregnancy: 'Planuję zajść w ciążę',
    weight_program_reproductive_status_option_breastfeeding: 'Karmię piersią',
    weight_program_reproductive_status_option_oral_contraceptives: 'Przyjmuję tabletki antykoncepcyjne',
    weight_program_reproductive_status_option_prefer_to_discuss: 'Wolę o tym porozmawiać',
    weight_program_mtc_men2_history_title: 'Czy Ty lub ktoś z Twojej rodziny miał MTC lub MEN2?',
    weight_program_mtc_men2_history_helper:
      "MTC to rak rdzeniasty tarczycy, rzadki nowotwór tarczycy. MEN2 to choroba, która powoduje guzy. Wybierz 'Nie jestem pewien/pewna', jeśli potrzebujesz pomocy.",
    weight_program_glp1_allergy_title:
      'Czy miałeś/miałaś poważną alergię na Foundayo lub inny lek na odchudzanie albo cukrzycę?',
    weight_program_glp1_allergy_detail_label: 'Nazwa leku (opcjonalnie)',
    weight_program_gi_organ_history_title: 'Czy miałeś/miałaś któryś z tych problemów zdrowotnych?',
    weight_program_gi_organ_history_option_pancreatitis: 'Zapalenie trzustki',
    weight_program_gi_organ_history_option_gallstones: 'Kamienie żółciowe',
    weight_program_gi_organ_history_option_gastroparesis: 'Bardzo wolne opróżnianie żołądka',
    weight_program_gi_organ_history_option_recurrent_vomiting: 'Nawracające wymioty',
    weight_program_gi_organ_history_option_kidney_disease: 'Choroba nerek',
    weight_program_gi_organ_history_option_severe_liver_disease: 'Poważna choroba wątroby',
    weight_program_gi_organ_history_option_diabetic_retinopathy: 'Uszkodzenie oczu spowodowane cukrzycą',
    weight_program_eating_disorder_screen_title: 'Czy miałeś/miałaś zaburzenia odżywiania lub któryś z tych problemów?',
    weight_program_eating_disorder_screen_helper:
      'Zaznacz wszystkie, które pasują, także te z przeszłości. Twoje odpowiedzi pomogą nam zaplanować wsparcie.',
    weight_program_eating_disorder_screen_option_anorexia_history:
      'Anoreksja (silne ograniczanie jedzenia i lęk przed przytyciem)',
    weight_program_eating_disorder_screen_option_bulimia_history:
      'Bulimia (napady objadania się, a potem próby ich „cofnięcia”)',
    weight_program_eating_disorder_screen_option_binge_or_other_history:
      'Zespół napadowego objadania się lub inne zaburzenie odżywiania',
    weight_program_eating_disorder_screen_option_restricting_from_fear: 'Pomijam posiłki, bo boję się przytyć',
    weight_program_eating_disorder_screen_option_purging_or_compensating:
      'Wymiotuję, biorę środki przeczyszczające lub moczopędne albo ćwiczę, żeby „odrobić” jedzenie',
    weight_program_eating_disorder_screen_option_loss_of_control_eating: 'Czasem czuję, że nie mogę przestać jeść',
    weight_program_eating_disorder_screen_option_prefer_to_discuss: 'Wolę porozmawiać o tym z lekarzem',
    weight_program_eating_disorder_screen_detail_label: 'Czy chcesz, żeby lekarz o czymś wiedział? (opcjonalnie)',
    weight_program_current_medications_title: 'Czy przyjmujesz jakieś leki lub suplementy?',
    weight_program_current_medications_helper:
      'Uwzględnij insulinę, leki na cukrzycę lub odchudzanie, produkty kupione przez internet, suplementy i antykoncepcję.',
    weight_program_current_medications_option_will_list: 'Tak',
    weight_program_current_medications_option_takes_none: 'Nie',
    weight_program_current_medications_option_need_help: 'Potrzebuję pomocy z listą',
    weight_program_current_medications_detail_label: 'Twoje leki i suplementy',
    weight_program_planned_anesthesia_title: 'Czy masz zaplanowaną operację lub znieczulenie?',
    weight_program_planned_anesthesia_helper: 'Znieczulenie to lek, który usypia Cię na czas zabiegu.',
    weight_program_planned_anesthesia_date_label: 'Data, jeśli ją znasz (opcjonalnie)',
    weight_program_support_needs_title: 'W czym chcesz uzyskać pomoc przed rozpoczęciem?',
    weight_program_support_needs_option_medicine_questions: 'Zrozumienie działania leku',
    weight_program_support_needs_option_side_effects: 'Skutki uboczne',
    weight_program_support_needs_option_cost_or_access: 'Koszt lub zdobycie leku',
    weight_program_support_needs_option_food_or_activity: 'Jedzenie lub aktywność fizyczna',
    weight_program_support_needs_option_other: 'Coś innego',
    weight_program_support_needs_option_ready_for_review: 'Jestem gotowy/gotowa na ocenę lekarza',
    weight_program_support_needs_detail_label: 'Czy chcesz, żeby lekarz o czymś wiedział? (opcjonalnie)',
    weight_program_decision_approved_title: 'Możesz zacząć – otrzymałeś/otrzymałaś zgodę',
    weight_program_decision_alternative_title: 'Lekarz proponuje inne leczenie',
    weight_program_decision_not_appropriate_title: 'Foundayo nie jest teraz odpowiednią opcją',
    weight_program_decision_status_approved: 'Zatwierdzono',
    weight_program_decision_status_alternative: 'Inne leczenie',
    weight_program_decision_status_not_appropriate: 'Nieodpowiednie',
    weight_program_decision_default_approved:
      'Lekarz sprawdził Twoje odpowiedzi i zgodził się, abyś zaczął/zaczęła przyjmować Foundayo.',
    weight_program_decision_default_alternative:
      'Lekarz sprawdził Twoje odpowiedzi i proponuje inne leczenie. Omówi z Tobą kolejne kroki.',
    weight_program_decision_default_not_appropriate:
      'Lekarz sprawdził Twoje odpowiedzi i uznał, że Foundayo nie jest teraz dla Ciebie odpowiednią opcją.',
    weight_program_decision_reviewed_by_label: 'Sprawdził(a)',
    weight_program_decision_message_from: 'Wiadomość od: dr {{doctor}}',
    weight_program_decision_message_from_dated: 'Wiadomość od: dr {{doctor}} ({{date}})',
    weight_program_decision_message_from_your_doctor: 'Wiadomość od lekarza',
    weight_program_decision_doctor_name: 'dr {{doctor}}',
    weight_program_decision_start_again: 'Zacznij od nowa',
    weight_program_decision_status_awaiting_start: 'Oczekuje na rozpoczęcie',
    weight_program_decision_medicine_label: 'Twój lek',
    weight_program_decision_prescription_label: 'Recepta',
    weight_program_decision_prescription_sent: 'Wysłana do Twojej apteki',
    weight_program_decision_prescription_preparing: 'Lekarz ją przygotowuje',
    weight_program_date_save: 'Zapisz',
    weight_program_date_save_failed: 'Nie udało się zapisać daty. Spróbuj ponownie.',
    weight_program_message_doctor: 'Napisz do mojego lekarza',
    weight_program_plan_note_from: 'Aktualny plan (dr {{doctor}}, {{date}})',
    weight_program_weight_title: 'Twoja waga',
    weight_program_history_title: 'Historia',
    weight_program_history_invited: 'Zaproszenie do programu',
    weight_program_history_consents: 'Zaakceptowano zgody',
    weight_program_history_form_sent: 'Wysłano pytania o zdrowie',
    weight_program_history_check_in_sent: 'Wysłano formularz kontrolny',
    weight_program_history_plan_updated_by: 'Plan zaktualizowany przez: dr {{doctor}}',
    weight_program_history_plan_updated: 'Zaktualizowano plan',
    weight_program_history_first_dose: 'Pierwsza tabletka',
    weight_program_history_dose_start: 'Rozpoczęcie nowej dawki',
    weight_program_history_check_in_opened: 'Udostępniono formularz kontrolny',
    weight_program_history_check_in_missed: 'Pominięto formularz kontrolny',
    weight_program_history_post_stop_check_in_sent: 'Wysłano formularz kontrolny po odstawieniu leku',
    weight_program_history_post_stop_check_in_opened: 'Udostępniono formularz kontrolny po odstawieniu leku',
    weight_program_history_post_stop_check_in_missed: 'Pominięto formularz kontrolny po odstawieniu leku',
    weight_program_decision_type_approve_to_start: 'Zgoda na rozpoczęcie',
    weight_program_decision_type_alternative_treatment: 'Inne leczenie',
    weight_program_decision_type_not_appropriate: 'Nieodpowiednie',
    weight_program_decision_type_continue: 'Kontynuacja',
    weight_program_decision_type_new_prescription: 'Nowa recepta',
    weight_program_decision_type_hold: 'Wstrzymano',
    weight_program_decision_type_stop: 'Przerwano',
    weight_program_decision_type_continue_post_stop: 'Kontynuacja obserwacji',
    weight_program_decision_type_close: 'Program zakończony',
    weight_program_first_dose_title: 'Daj nam znać, kiedy zaczniesz',
    weight_program_first_dose_body:
      'Comiesięczne formularze kontrolne są planowane od dnia przyjęcia pierwszej tabletki, a nie od daty wystawienia recepty. Możesz zmienić datę, dopóki nie zostanie udostępniony pierwszy formularz kontrolny.',
    weight_program_first_dose_label: 'Data przyjęcia pierwszej tabletki',
    weight_program_first_dose_change_label:
      'Data przyjęcia pierwszej tabletki (możesz ją zmienić, dopóki nie zostanie udostępniony pierwszy formularz kontrolny)',
    weight_program_dose_start_title: 'Lekarz zaktualizował Twój plan',
    weight_program_dose_start_decision_label: 'Decyzja',
    weight_program_dose_start_plan_label: 'Nowy plan',
    weight_program_dose_start_form_title: 'Daj nam znać, kiedy zaczniesz nowy plan',
    weight_program_dose_start_label: 'Pierwszy dzień przyjmowania: {{medicine}}',
    weight_program_check_in_due_title: 'Czas na comiesięczny formularz kontrolny',
    weight_program_check_in_due_body:
      '10 krótkich pytań o Twoją wagę, lek i samopoczucie. Lekarz sprawdza każdy formularz kontrolny, nawet gdy wszystko jest w porządku.',
    weight_program_check_in_label: 'Formularz kontrolny',
    weight_program_check_in_cycle: 'Cykl {{number}} · udostępniono {{date}}',
    weight_program_plan_dose_label: 'Aktualna dawka',
    weight_program_plan_dose_since: '{{medicine}} od {{date}}',
    weight_program_check_in_last_weight_label: 'Ostatnio podana waga',
    weight_program_check_in_start: 'Wypełnij formularz kontrolny',
    weight_program_check_in_help:
      'Jeśli przed kolejnym formularzem kontrolnym pojawi się nowy problem, skontaktuj się z Tap przez czat, zamiast czekać na comiesięczny formularz.',
    weight_program_check_in_submitted_title: 'Dziękujemy. Twoja aktualizacja trafiła do lekarza.',
    weight_program_check_in_submitted_body:
      'Lekarz Tap ją sprawdzi i poinformuje Cię o kolejnym kroku. Twoje odpowiedzi nie zmieniają recepty.',
    weight_program_check_in_view_answers: 'Zobacz',
    weight_program_check_in_submitted_keep_taking:
      'Przyjmuj lek zgodnie z zaleceniem, dopóki lekarz nie zdecyduje inaczej. Jeśli przed kolejnym formularzem kontrolnym pojawi się nowy problem, skontaktuj się z Tap przez czat.',
    weight_program_treatment_title: 'Twój plan leczenia Foundayo',
    weight_program_on_hold_title: 'Lekarz wstrzymał plan',
    weight_program_stopped_title: 'Twój program się zakończył',
    weight_program_status_on_treatment: 'W trakcie leczenia',
    weight_program_status_on_hold: 'Wstrzymane przez lekarza',
    weight_program_status_stopped: 'Przerwane',
    weight_program_status_post_stop: 'Lek odstawiony · obserwacja',
    weight_program_post_stop_next_check_in: '{{date}} (formularz kontrolny {{number}} z 2)',
    weight_program_post_stop_due_title: 'Czas na krótki formularz kontrolny',
    weight_program_post_stop_due_body:
      '5 krótkich pytań o Twoją wagę i samopoczucie od odstawienia Foundayo. Lekarz sprawdza każdy formularz kontrolny.',
    weight_program_post_stop_check_in_value: '{{number}} z 2 · odpowiedz do {{date}}',
    weight_program_post_stop_stopped_label: 'Lek odstawiony',
    weight_program_post_stop_help:
      'Jeśli pojawi się nowy problem, skontaktuj się z Tap przez czat, zamiast czekać na formularz kontrolny.',
    weight_program_post_stop_submitted_body: 'Lekarz Tap ją sprawdzi i poinformuje Cię o kolejnym kroku.',
    weight_program_post_stop_eyebrow: 'Kontrola po odstawieniu leku',
    weight_program_post_stop_wellbeing_title: 'Jak się czujesz od odstawienia leku?',
    weight_program_post_stop_wellbeing_option_better: 'Lepiej',
    weight_program_post_stop_wellbeing_option_same: 'Mniej więcej tak samo',
    weight_program_post_stop_wellbeing_option_worse: 'Gorzej',
    weight_program_post_stop_wellbeing_detail_label: 'Co się zmieniło? (opcjonalnie)',
    weight_program_post_stop_eating_title: 'Czy martwi Cię coś w związku z jedzeniem lub apetytem?',
    weight_program_post_stop_eating_option_none: 'Nic mnie nie martwi',
    weight_program_post_stop_eating_option_concerned: 'Martwię się o swoje jedzenie lub apetyt',
    weight_program_post_stop_eating_option_prefer_to_discuss: 'Wolę o tym porozmawiać',
    weight_program_post_stop_eating_detail_label: 'Co Cię martwi? (opcjonalnie)',
    weight_program_post_stop_next_step_title: 'Co chcesz zrobić dalej?',
    weight_program_post_stop_next_step_option_fine: 'Czuję się dobrze, nic więcej nie potrzebuję',
    weight_program_post_stop_next_step_option_talk_to_doctor: 'Chcę porozmawiać z lekarzem',
    weight_program_post_stop_next_step_option_return_to_treatment: 'Chcę porozmawiać o ponownym rozpoczęciu leczenia',
    weight_program_post_stop_next_step_detail_label: 'Co chcesz przekazać lekarzowi? (opcjonalnie)',
    weight_program_next_check_in_paused: 'Wstrzymano, brak zaplanowanego formularza kontrolnego',
    weight_program_plan_dose_start_label: 'Przyjmujesz tę dawkę od',
    weight_program_plan_started_label: 'Rozpoczęcie programu',
    weight_program_plan_next_check_in_label: 'Następny formularz kontrolny',
    weight_program_monthly_eyebrow: 'Comiesięczna kontrola',
    weight_program_monthly_review_helper:
      'Przed wysłaniem możesz wrócić i wszystko zmienić. Po wysłaniu lekarz sprawdza te odpowiedzi; zmiany zgłaszasz przez czat.',
    weight_program_monthly_problem_weight_incomplete: 'Podaj wagę, jednostkę i datę.',
    weight_program_monthly_weight_title: 'Ile dziś ważysz?',
    weight_program_monthly_weight_helper: 'Podaj niedawno zmierzoną wartość.',
    weight_program_monthly_weight_helper_previous:
      'Podaj niedawno zmierzoną wartość. Ostatnio podałeś/podałaś {{weight}} ({{date}}).',
    weight_program_monthly_weight_label: 'Dzisiejsza waga',
    weight_program_monthly_dose_match_title: 'Czy to zgadza się z tym, co przyjmujesz?',
    weight_program_monthly_dose_match_helper: 'W Twojej dokumentacji jest {{medicine}} codziennie, od {{date}}.',
    weight_program_monthly_dose_match_helper_no_date: 'W Twojej dokumentacji jest {{medicine}} codziennie.',
    weight_program_monthly_dose_match_option_same: 'Tak, dawka i data są prawidłowe',
    weight_program_monthly_dose_match_option_different: 'Dawka lub data rozpoczęcia jest inna',
    weight_program_monthly_dose_match_option_stopped: 'Przestałem/przestałam go przyjmować',
    weight_program_monthly_dose_match_option_not_started: 'Jeszcze nie zacząłem/zaczęłam',
    weight_program_monthly_dose_match_detail_label:
      'Twoja faktyczna dawka, data rozpoczęcia lub data ostatniej dawki (jeśli ją znasz)',
    weight_program_monthly_missed_days_title: 'Ile dni w tym miesiącu pominąłeś/pominęłaś lek?',
    weight_program_monthly_missed_days_helper: 'Wystarczy przybliżona liczba, jeśli nie pamiętasz dokładnie.',
    weight_program_monthly_missed_days_label: 'Łączna liczba pominiętych dni w tym miesiącu',
    weight_program_monthly_missed_days_in_a_row_label: 'Najwięcej pominiętych dni z rzędu',
    weight_program_monthly_missed_days_summary: 'Łącznie dni: {{count}}, z rzędu: {{inARow}}',
    weight_program_monthly_appetite_title: 'Jak lek pomaga Ci radzić sobie z głodem i zachciankami?',
    weight_program_monthly_appetite_option_helping: 'Pomaga, a nadal mogę jeść normalne posiłki',
    weight_program_monthly_appetite_option_still_hungry: 'Głód lub zachcianki wciąż trudno opanować',
    weight_program_monthly_appetite_option_little_appetite: 'Mam tak mały apetyt, że trudno mi jeść',
    weight_program_monthly_appetite_option_no_change: 'Nie zauważyłem/zauważyłam zmiany',
    weight_program_monthly_side_effects_title: 'Jak bardzo dokuczały Ci skutki uboczne?',
    weight_program_monthly_side_effects_helper:
      'Na przykład: nudności, wymioty, biegunka, zaparcia lub inne nowe objawy.',
    weight_program_monthly_side_effects_option_none: 'Wcale',
    weight_program_monthly_side_effects_option_mild: 'Łagodnie, mogę wykonywać zwykłe czynności',
    weight_program_monthly_side_effects_option_interfere: 'Utrudniają mi jedzenie lub codzienne czynności',
    weight_program_monthly_side_effects_option_severe: 'Są bardzo nasilone',
    weight_program_monthly_side_effects_detail_label: 'Jaki skutek uboczny i jak często? (jeśli wiesz)',
    weight_program_monthly_eating_and_fluids_title: 'Jak radzisz sobie z jedzeniem, piciem i codziennymi czynnościami?',
    weight_program_monthly_eating_and_fluids_option_usual: 'Mogę jeść, pić i wykonywać zwykłe czynności',
    weight_program_monthly_eating_and_fluids_option_hard_to_eat: 'Trudno mi jeść normalne posiłki',
    weight_program_monthly_eating_and_fluids_option_hard_to_drink: 'Trudno mi wypić wystarczająco dużo płynów',
    weight_program_monthly_eating_and_fluids_option_cannot_keep_fluids: 'Nie mogę utrzymać w sobie płynów',
    weight_program_monthly_eating_and_fluids_option_less_urine: 'Oddaję znacznie mniej moczu',
    weight_program_monthly_eating_and_fluids_option_weaker:
      'Czuję się słabszy/słabsza lub codzienne czynności sprawiają mi więcej trudności',
    weight_program_monthly_warning_signs_title: 'Czy wystąpił u Ciebie któryś z tych niepokojących objawów?',
    weight_program_monthly_warning_signs_helper:
      'Zaznacz wszystkie, które pasują. W nagłym przypadku od razu wezwij pomoc; nie czekaj z dokończeniem formularza.',
    weight_program_monthly_warning_signs_option_persistent_belly_pain: 'Silny ból brzucha, który nie mija',
    weight_program_monthly_warning_signs_option_yellow_skin_or_eyes: 'Zażółcenie skóry lub oczu',
    weight_program_monthly_warning_signs_option_vision_trouble: 'Nowe problemy ze wzrokiem',
    weight_program_monthly_warning_signs_option_neck_lump_or_hoarse: 'Guzek na szyi lub utrzymująca się chrypka',
    weight_program_monthly_warning_signs_option_face_or_tongue_swelling: 'Obrzęk twarzy lub języka',
    weight_program_monthly_warning_signs_option_trouble_breathing: 'Trudności z oddychaniem',
    weight_program_monthly_warning_signs_option_low_blood_sugar:
      'Niski poziom cukru we krwi, drżenie, pocenie się, uczucie omdlenia lub splątanie',
    weight_program_monthly_warning_signs_detail_label: 'Kiedy to się stało i co się działo? (opcjonalnie)',
    weight_program_monthly_changes_title: 'Czy coś z poniższych zmieniło się od ostatniego formularza kontrolnego?',
    weight_program_monthly_changes_option_medicines: 'Nowe, odstawione lub zmienione leki albo suplementy',
    weight_program_monthly_changes_option_health: 'Nowy problem zdrowotny lub coś innego',
    weight_program_monthly_changes_option_pregnant: 'Jestem w ciąży lub mogę być w ciąży',
    weight_program_monthly_changes_option_planning_pregnancy: 'Planuję zajść w ciążę',
    weight_program_monthly_changes_option_breastfeeding: 'Karmię piersią',
    weight_program_monthly_changes_option_birth_control_pills: 'Tabletki antykoncepcyjne',
    weight_program_monthly_changes_option_periods_changed:
      'Miesiączki ustały lub zmieniły się w sposób, którego nie potrafię wyjaśnić',
    weight_program_monthly_changes_option_procedure_planned: 'Mam zaplanowaną operację lub znieczulenie',
    weight_program_monthly_changes_option_none: 'Brak zmian',
    weight_program_monthly_changes_detail_label: 'Napisz lekarzowi coś więcej (opcjonalnie)',
    weight_program_monthly_changes_reported_title: 'Leki, które podałeś wcześniej',
    weight_program_monthly_changes_reported_helper:
      'Tak nam napisałeś ostatnim razem. Jeśli coś się zmieniło, wybierz pierwszą opcję poniżej i zaktualizuj listę.',
    weight_program_monthly_changes_medications_label: 'Twoje obecne leki i suplementy (wymagane)',
    weight_program_monthly_changes_medications_helper:
      'Wpisaliśmy Twoją ostatnią listę. Dodaj, usuń lub zmień to, co jest teraz inne.',
    weight_program_monthly_changes_medications_summary: 'Obecne leki: {{list}}',
    weight_program_monthly_eating_concerns_title: 'Czy coś z tego zdarzyło się w tym miesiącu?',
    weight_program_monthly_eating_concerns_helper:
      'Zaznacz wszystkie, które pasują. Pytamy o to wszystkich, aby wspierać bezpieczne leczenie.',
    weight_program_monthly_eating_concerns_option_restricting_from_fear: 'Pomijam posiłki, bo boję się przytyć',
    weight_program_monthly_eating_concerns_option_purging_or_compensating:
      'Wymiotuję, biorę środki przeczyszczające lub moczopędne albo ćwiczę, żeby „odrobić” jedzenie',
    weight_program_monthly_eating_concerns_option_loss_of_control_eating: 'Czasem czuję, że nie mogę przestać jeść',
    weight_program_monthly_eating_concerns_option_worries_interfere:
      'Zmartwienia związane z jedzeniem lub wagą utrudniają mi codzienne życie',
    weight_program_monthly_eating_concerns_option_dose_change_upsetting:
      'Zmniejszenie dawki lub odstawienie leku bardzo mnie niepokoi',
    weight_program_monthly_eating_concerns_option_took_extra: 'Przyjąłem/przyjęłam więcej leku, niż mi przepisano',
    weight_program_monthly_eating_concerns_option_other_source:
      'Stosowałem/stosowałam lek na odchudzanie z innego źródła',
    weight_program_monthly_eating_concerns_option_prefer_to_discuss: 'Wolę porozmawiać o tym z lekarzem',
    weight_program_monthly_eating_concerns_detail_label: 'Czy chcesz się czymś podzielić? (opcjonalnie)',
    weight_program_monthly_plan_preference_title: 'Co chcesz omówić w sprawie swojego planu?',
    weight_program_monthly_plan_preference_helper:
      'Zaznacz wszystkie, które pasują. Twoja odpowiedź nie zmienia dawki.',
    weight_program_monthly_plan_preference_option_continue: 'Pozostanie przy obecnym planie',
    weight_program_monthly_plan_preference_option_increase: 'Większa pomoc w osiągnięciu celu lub wyższa dawka',
    weight_program_monthly_plan_preference_option_decrease: 'Niższa dawka lub pomoc ze skutkami ubocznymi',
    weight_program_monthly_plan_preference_option_maintain:
      'Jestem blisko docelowego zakresu wagi lub w nim i chcę go utrzymać',
    weight_program_monthly_plan_preference_option_losing_too_much: 'Chudnę bardziej, niż bym chciał/chciała',
    weight_program_monthly_plan_preference_option_need_goal: 'Potrzebuję pomocy w ustaleniu celu',
    weight_program_monthly_plan_preference_option_stop: 'Odstawienie leku lub przeniesienie opieki',
    weight_program_monthly_plan_preference_option_cost_or_access: 'Koszt lub zdobycie leku',
    weight_program_monthly_plan_preference_option_question: 'Inne pytanie',
    weight_program_monthly_plan_preference_detail_label: 'Co chcesz przekazać lekarzowi? (opcjonalnie)',

    // Phone-first auth
    phone_auth_error_generic: 'Coś poszło nie tak. Spróbuj ponownie.',
    google_sign_in_error: 'Nie udało się połączyć z usługą uwierzytelniania Google. Spróbuj ponownie.',
    profile_updated_success: 'Profil został zaktualizowany!',
    phone_auth_error_rate_limited: 'Zbyt wiele prób, spróbuj ponownie za kilka minut.',
    phone_auth_error_session_expired: 'Twoja sesja rejestracji wygasła. Zacznij od nowa.',
    phone_auth_error_code_invalid: 'Ten kod jest nieprawidłowy. Sprawdź go i spróbuj ponownie.',
    phone_auth_error_code_expired: 'Ten kod wygasł. Poproś o nowy.',
    phone_auth_error_code_send_failed: 'Nie udało się wysłać kodu. Spróbuj ponownie.',
    phone_auth_error_patient_required: 'To konto nie ma jeszcze rekordu pacjenta.',
    phone_auth_error_email_not_verified: 'Najpierw potwierdź swój adres e-mail.',
    phone_auth_error_patient_not_allowed: 'Ten rekord nie jest dostępny dla tego numeru.',
    phone_auth_error_already_claimed: 'Ten rekord jest już powiązany z kontem. Zaloguj się.',
    phone_auth_error_already_registered: 'Jesteś już zarejestrowany. Zaloguj się.',
    phone_auth_error_already_confirmed: 'Ten numer jest już potwierdzony.',
    phone_auth_error_dob_required: 'Podaj swoją datę urodzenia.',
    phone_auth_error_dob_mismatch:
      'Podana data urodzenia nie zgadza się z naszymi danymi. Wyślij nam SMS z tego telefonu, a lekarz sprawdzi Twoje dane.',
    phone_auth_error_dob_attempts_exceeded:
      'Zbyt wiele nieprawidłowych prób. Odczekaj 20 minut i spróbuj ponownie lub wyślij nam SMS z tego telefonu, a lekarz sprawdzi Twoje dane.',
    phone_auth_error_must_be_adult: 'Aby utworzyć konto, musisz mieć ukończone 18 lat.',
    phone_auth_error_hipaa_required: 'Zaakceptuj umowę dotyczącą prywatności, aby kontynuować.',
    phone_auth_error_terms_required: 'Zaakceptuj Warunki korzystania i Politykę prywatności, aby kontynuować.',
    phone_auth_error_same_number: 'To Twój własny numer. Podaj osobisty numer telefonu drugiej osoby dorosłej.',
    phone_auth_error_phone_required: 'Podaj numer telefonu.',
    phone_auth_error_number_has_account: 'Ten numer należy już do konta. Użyj innego numeru.',
    phone_auth_error_register_by_phone:
      'Nie ma konta dla tego adresu e-mail Google. Najpierw zarejestruj się za pomocą numeru telefonu.',
    phone_auth_invalid_phone: 'Podaj prawidłowy amerykański numer telefonu.',
    phone_auth_code_sent_to: 'Wpisz 6-cyfrowy kod wysłany na {{target}}.',
    phone_auth_resend: 'Wyślij nowy kod',
    phone_auth_resend_wait: 'Wyślij nowy kod ({{seconds}} s)',
    phone_auth_change_number: 'Użyj innego numeru',
    phone_auth_change_email: 'Użyj innego adresu e-mail',
    phone_auth_verify_title: 'Zweryfikuj swój numer telefonu',
    phone_auth_login_title: 'Zaloguj się',
    phone_auth_login_subtitle: 'Podaj numer telefonu. Wyślemy jednorazowy kod SMS-em.',
    phone_auth_use_email_instead: 'Zaloguj się za pomocą adresu e-mail',
    phone_auth_use_phone_instead: 'Zaloguj się za pomocą numeru telefonu',
    phone_auth_email_login_title: 'Zaloguj się za pomocą adresu e-mail',
    phone_auth_email_login_subtitle: 'Wyślemy jednorazowy kod na Twój adres e-mail.',
    phone_auth_check_email: 'Sprawdź swoją pocztę e-mail',
    phone_auth_email_code_hint:
      'Jeśli ten adres e-mail jest powiązany z kontem, wysłaliśmy kod. Kod jest ważny przez 10 minut. Wpisz go poniżej.',
    phone_auth_no_account_continue_phone: 'Nie masz jeszcze konta? Kontynuuj za pomocą numeru telefonu',
    phone_auth_no_account_title: 'Nie masz jeszcze konta',
    phone_auth_no_account_text:
      'Twój numer jest zweryfikowany, ale nie ma dla niego konta. Możesz teraz utworzyć profil pacjenta. Zajmie to około minuty.',
    phone_auth_create_profile: 'Utwórz mój profil',
    phone_auth_create_account: 'Utwórz swoje konto',
    phone_auth_register_title: 'Utwórz swoje konto',
    phone_auth_register_subtitle: 'Podaj numer telefonu. Wyślemy jednorazowy kod SMS-em. Hasło nie jest potrzebne.',
    phone_auth_sign_in: 'Zaloguj się',
    phone_auth_account_exists_title: 'Masz już konto',
    phone_auth_account_exists_text: 'Ten numer jest powiązany z istniejącym kontem, więc Cię zalogowaliśmy.',
    phone_auth_choose_title: 'Który rekord jest Twój?',
    phone_auth_choose_subtitle:
      'Z tego numeru korzysta kilka osób. Wybierz siebie. Pokazujemy tylko krótkie imię i rok urodzenia.',
    phone_auth_choose_none: 'Nie ma mnie na tej liście, dodaj mnie',
    phone_auth_choose_hint:
      'Nie rozpoznajesz kogoś z tej listy? Wyślij nam SMS z tego telefonu, abyśmy mogli sprawdzić numer.',
    phone_auth_found_title: 'Znaleźliśmy Twój rekord pacjenta',
    phone_auth_found_subtitle:
      'Historia Twojej opieki zostanie połączona z tym kontem. Potwierdź swoje dane, aby kontynuować.',
    phone_auth_profile_title: 'Utwórz swój profil pacjenta',
    phone_auth_profile_subtitle: 'Nie znaleźliśmy istniejącego rekordu pacjenta dla tego numeru telefonu.',
    phone_auth_add_email_title: 'Dodaj swój adres e-mail',
    phone_auth_email_hint:
      'Mamy zapisany adres e-mail kończący się na {{hint}}. Wpisz go, aby otrzymać kod, lub użyj innego adresu e-mail.',
    phone_auth_add_email_subtitle:
      'Adres e-mail to zapasowy sposób logowania, jeśli utracisz dostęp do swojego numeru telefonu.',
    phone_auth_heard_title: 'Ostatnie pytanie',
    phone_auth_finish: 'Zakończ',
    phone_auth_skip: 'Pomiń',
    phone_auth_profile_ready: 'Twój profil jest gotowy',
    phone_auth_invitation_invalid: 'Ten link z zaproszeniem jest nieprawidłowy.',
    phone_auth_invitation_invalid_title: 'Ten link z zaproszeniem jest już nieważny',
    phone_auth_invitation_invalid_text:
      'Został już użyty lub wygasł. Jeśli masz już skonfigurowane konto, zaloguj się za pomocą numeru telefonu. W przeciwnym razie poproś swojego lekarza o nowe zaproszenie.',
    phone_auth_invitation_title: 'Potwierdź swój numer telefonu',
    phone_auth_invitation_hint: 'Wyślemy kod na numer telefonu z Twojego rekordu, kończący się na {{hint}}.',
    phone_auth_invitation_another_number: 'To już nie jest mój numer',
    phone_auth_invitation_other_number: 'Podaj numer telefonu, którego chcesz używać. Wyślemy jednorazowy kod SMS-em.',
    phone_auth_invitation_no_number:
      'W Twoim rekordzie nie ma numeru telefonu. Podaj swój, a wyślemy jednorazowy kod SMS-em.',
    phone_auth_invitation_use_record_number: 'Użyj numeru z mojego rekordu',
    phone_auth_claim_invalid_link: 'Ten link jest nieprawidłowy.',
    phone_auth_claim_hello: 'Witaj, {{name}}',
    phone_auth_claim_subtitle: 'Potwierdź numer telefonu kończący się na {{hint}}. Będzie używany tylko dla Ciebie.',
    phone_auth_claim_confirm: 'Potwierdź',
    phone_auth_claim_done_title: 'Dziękujemy, Twój numer jest potwierdzony',
    phone_auth_claim_done_text: 'Możesz teraz zalogować się do Portalu Pacjenta za pomocą tego numeru.',
    phone_auth_claim_already_used: 'Ten link został już użyty.',
    phone_auth_add_phone_title: 'Dodaj swój numer telefonu',
    phone_auth_add_phone_text: 'Podaj numer telefonu. Wyślemy jednorazowy kod SMS-em.',
    phone_auth_add_phone_banner:
      'Twoje konto nie ma jeszcze zweryfikowanego numeru telefonu. Dodaj go, aby następnym razem logować się szybciej i abyśmy mogli wysyłać Ci SMS-y dotyczące Twojej opieki.',
    phone_auth_add_phone_cta: 'Dodaj numer',
    phone_auth_add_phone_done: 'Twój numer telefonu jest zweryfikowany',
    phone_auth_shared_title: 'Inne osoby dorosłe w Twoim gospodarstwie domowym używają tego numeru',
    phone_auth_shared_text:
      'Każda osoba dorosła potrzebuje własnego numeru, abyśmy mogli zachować prywatność jej opieki. Podaj jej numer telefonu, a wyślemy jej SMS z linkiem do potwierdzenia.',
    phone_auth_shared_cta: 'Podaj jej numer',
    phone_auth_became_adult: '{{name}} jest już dorosły',
    phone_auth_their_number: 'Jej numer telefonu',
    phone_auth_send_link: 'Wyślij link',
    phone_auth_has_login_note: 'Ten rekord ma już konto. Potwierdź swoją datę urodzenia, aby się zalogować.',
    phone_auth_link_sent: 'Link wysłany',
    // Google connect
    phone_auth_error_google_state_invalid: 'To potwierdzenie Google wygasło lub zostało już użyte. Spróbuj ponownie.',
    phone_auth_error_google_state_forbidden:
      'To potwierdzenie Google nie należy do Twojej bieżącej sesji. Spróbuj ponownie.',
    phone_auth_error_google_email_unverified: 'Google nie zweryfikowało tego adresu e-mail. Użyj innego konta Google.',
    phone_auth_error_google_account_in_use: 'To konto Google jest już połączone z innym loginem.',
    phone_auth_google_confirm: 'Potwierdź przez Google',
    google_cancelled: 'Logowanie przez Google zostało anulowane',
    google_session_missing: 'Zaloguj się i spróbuj ponownie.',
    google_connected_success: 'Konto Google połączone',
    google_email_changed_success: 'Twój adres e-mail do logowania został zaktualizowany',
    signin_methods_load_error: 'Nie udało się załadować sposobów logowania. Spróbuj ponownie później.',
    signin_methods_title: 'Sposoby logowania',
    signin_methods_phone: 'Numer telefonu',
    signin_methods_email: 'Adres e-mail',
    signin_methods_google: 'Google',
    signin_methods_verified: 'Zweryfikowany',
    signin_methods_not_confirmed: 'Niepotwierdzony',
    signin_methods_not_verified: 'Niezweryfikowany',
    signin_methods_connected: 'Połączone',
    signin_methods_not_connected: 'Niepołączone',
    signin_methods_connected_since: 'od {{date}}',
    signin_methods_google_default: 'Działa z adresem e-mail Twojego konta',
    signin_methods_use_other_google: 'Użyj innego konta Google',
    signin_methods_connect_google: 'Połącz z Google',
    signin_methods_not_set: 'Nie ustawiono',
    google_email_change_title: 'Zmień adres e-mail do logowania',
    google_email_change_text: 'Twój adres e-mail do logowania zmieni się z {{old}} na {{new}}. Kontynuować?',
  },
}
